var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _polygon, _polygon2, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAidiAboutUscrdImg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-244"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M703.55,155.89c.59-4.28-5.44-7.79-10-8.16-2.16-.17-4.4.16-6.45-.55-4.43-1.55-6.21-7.28-10.53-9.11-3.24-1.36-7-.15-10.1,1.43s-6.24,3.57-9.74,3.79c-3,.2-6.36-.93-9,.56-2,1.11-3,3.4-4.86,4.75s-4.13,1.6-6.35,1.72-4.53.14-6.55,1.07-3.7,3.07-3.28,5.26Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.54,70.75a19.72,19.72,0,0,0-17.27,10.87,7.55,7.55,0,0,0-.92,4.76,3.5,3.5,0,0,0,3.43,2.92,4.36,4.36,0,0,0,2.79-1.8c2.19-2.67,3-6.15,4.33-9.36s3.38-6.46,6.7-7.42",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.8,85.84a23,23,0,0,0-1.15-3,23.15,23.15,0,0,1-1.44-5.43l-.45.42a12.81,12.81,0,0,0-2.32,9.27,5.46,5.46,0,0,0,.71,2.23A2.7,2.7,0,0,0,437,90.59,2.65,2.65,0,0,0,439.62,89,4.69,4.69,0,0,0,439.8,85.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.38,459.36a9.29,9.29,0,0,1-2-13.44,9.53,9.53,0,1,1,13.11-13.78,11.71,11.71,0,0,0,2.56,2.51c2,1.12,4.79.19,6.64,1.55a4.33,4.33,0,0,1,1.56,3.26,12.78,12.78,0,0,1-.52,3.68,11.56,11.56,0,0,1-2.15,5.07c-1.85,2.08-4.86,2.51-7.49,3.44a18.45,18.45,0,0,0-10,8.64c.07-.19.15-.37.22-.56",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.5,468.33c-1-.87-3.28-3.63-1.53-6.84.64-1.18,2-1.76,3.23-2.28a13,13,0,0,0,3.55-1.84c1.92-1.63,2.45-4.35,3.73-6.53a8.15,8.15,0,0,1,7.09-4.25c3.31.15,6.07,2.85,7.32,5.93s1.29,6.5,1.32,9.83c0,1.84-.07,3.92-1.42,5.16s-3.12,1.16-4.81,1.11l-18.08-.56",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.09,418.61H288.54l8.56,51.08a5.72,5.72,0,0,0,4.06,4.55l.17,0a3.25,3.25,0,0,0,.42.11,5.15,5.15,0,0,0,1,.11v.05l.23,0h21.19a6.45,6.45,0,0,0,1.17-.11,5.74,5.74,0,0,0,4.81-5l4.13-35.2.18-1.4h0l1.64-13.93Zm-9,32.58h-4.88l.49-14.82h5.65Zm1.74-14.82h4.67l-1.74,14.82h-4.2Zm-13.94,31.26-.3-12.88h7l-.43,12.88Zm-7.6-12.88h6.83l.29,12.88h-6.12Zm.53,12.88h-5.73c-.54-3.48-1.25-8-2-12.88h6.75ZM307,451.19l-1.15-14.82h7.83l.35,14.82Zm7.5,0-.34-14.82h8.06l-.49,14.82Zm-.43-18.38-.31-13.72h9l-.45,13.72Zm-.47,0h-8l-1.06-13.72h8.78Zm-8.5,0h-8.49c-.3-1.89-.59-3.69-.85-5.3-.88-5.55-1.22-7.64-1.4-8.42h9.67Zm.28,3.56,1.15,14.82h-7c-.23-1.5-.47-3-.71-4.55-.55-3.5-1.1-7-1.62-10.27Zm-6.35,14.82h-4.59L292,436.37h4.74C297.46,441,298.26,446.05,299.07,451.19Zm.56,3.56c.69,4.45,1.38,8.85,2,12.88h-4.41l-2.16-12.88Zm22.06,12.88.43-12.88h4.69l-1.1,12.88Zm1.16-34.82.45-13.72h6.56l-1.17,13.72ZM294,419.09c.19,1,1.06,6.39,2.22,13.72H291.4l-2.31-13.72Zm35.91,48.54h-3.67l1.1-12.88h4.08ZM334,432.81h-4.79l1.17-13.72h5.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.5,425l9.48-.74,6.54,5.74-1.91,2.11-2.71.05-.32,3.92-5.65.34.15-5.08s-1.39-1.51-2.12-.72-1,5.05-4,5.46l-.54-.79a7.18,7.18,0,0,0,2.89-5.84s-.09-1.12-.69-1.24a5.28,5.28,0,0,0-1.4,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360,436.12s-7.53,30.43-6.65,38.17l21.35-.47-9.17-38.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "354.19 428.16 352.16 427.83 352.27 425.31 354.5 424.97 354.19 428.16",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.3,424.94a4.3,4.3,0,0,1,.06,1.63,4.55,4.55,0,0,1-.31,1.6,7.59,7.59,0,0,1,.08-1.62A8.72,8.72,0,0,1,354.3,424.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.11,430.61a4.27,4.27,0,0,1-1.73-.81,4.49,4.49,0,0,1-1.37-1.34c.05,0,.65.56,1.5,1.15S359.14,430.55,359.11,430.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.58,95.8c.44-3.14-4-5.73-7.33-6-1.59-.13-3.24.11-4.75-.41-3.26-1.14-4.56-5.35-7.74-6.7-2.38-1-5.12-.11-7.43,1s-4.58,2.63-7.16,2.79c-2.24.14-4.67-.69-6.64.41-1.46.81-2.22,2.5-3.57,3.49a8.56,8.56,0,0,1-4.67,1.27,13.22,13.22,0,0,0-4.82.78c-1.49.69-2.72,2.26-2.41,3.87Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,159.2c.61-4.4-5.6-8-10.27-8.39-2.22-.18-4.53.16-6.64-.57-4.57-1.6-6.39-7.5-10.85-9.38-3.33-1.4-7.17-.15-10.4,1.48s-6.42,3.67-10,3.9c-3.14.2-6.55-1-9.3.57-2,1.14-3.12,3.5-5,4.89s-4.25,1.65-6.54,1.77-4.66.15-6.75,1.11-3.81,3.15-3.37,5.41Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299,70.65c.61-4.4-5.6-8-10.27-8.39-2.22-.18-4.53.16-6.64-.57-4.57-1.6-6.39-7.5-10.85-9.37-3.33-1.41-7.17-.16-10.4,1.47s-6.42,3.67-10,3.9c-3.14.2-6.55-1-9.3.57-2,1.14-3.12,3.5-5,4.89s-4.25,1.65-6.54,1.77-4.66.15-6.75,1.11-3.81,3.15-3.37,5.41Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.17,97c.77-5.59-7.13-10.2-13.06-10.68-2.83-.22-5.77.21-8.45-.73-5.81-2-8.13-9.53-13.8-11.92-4.24-1.78-9.12-.19-13.23,1.87s-8.17,4.67-12.76,5c-4,.25-8.32-1.23-11.82.72-2.6,1.46-4,4.46-6.36,6.23s-5.41,2.09-8.32,2.25-5.93.19-8.58,1.4-4.85,4-4.3,6.89Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.71,31.66s-.41-.11-1.14-.26a9.42,9.42,0,0,0-3.14-.08,8.42,8.42,0,0,0-4.2,1.84,8.74,8.74,0,0,0-3,4.71l0,.05-.18.7-.27-.66a9.39,9.39,0,0,0-3.54-4.3,9.23,9.23,0,0,0-4.34-1.47,12.09,12.09,0,0,0-4.25.54,3.47,3.47,0,0,1,1.08-.47,9,9,0,0,1,3.19-.4,9.23,9.23,0,0,1,4.55,1.44,9.67,9.67,0,0,1,3.75,4.48l-.45,0,0-.06A9,9,0,0,1,451,32.82,8.58,8.58,0,0,1,455.39,31a8.49,8.49,0,0,1,3.22.23A3.25,3.25,0,0,1,459.71,31.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.89,43.24s-.37.43-1,1.2a26.38,26.38,0,0,0-2.55,3.46,25.26,25.26,0,0,0-3.79,13.46v.17l-.46,0a22.64,22.64,0,0,0-6.2-12.35,30.21,30.21,0,0,0-4.53-3.67,1.32,1.32,0,0,1,.38.17c.23.13.59.3,1,.58A20.43,20.43,0,0,1,317.07,49a21.89,21.89,0,0,1,3.89,5.1,22.13,22.13,0,0,1,2.54,7.42l-.47,0v-.17a24.76,24.76,0,0,1,4-13.65,22.49,22.49,0,0,1,2.7-3.41,11.51,11.51,0,0,1,.85-.82C330.77,43.31,330.88,43.22,330.89,43.24Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-244"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.89,359.43c-6.2,3.22-11,8.74-14.37,14.83s-5.62,12.77-7.81,19.4l-1.91,34.2c7.22-12.27,13-26.7,14.57-40.84l-4.8-.43c3.22-.49,5.92-2.82,7.64-5.59a34.12,34.12,0,0,0,3.47-9.09l-5.86.87A21.69,21.69,0,0,0,260.89,359.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M260.89,359.43c-6.2,3.22-11,8.74-14.37,14.83s-5.62,12.77-7.81,19.4l-1.91,34.2c7.22-12.27,13-26.7,14.57-40.84l-4.8-.43c3.22-.49,5.92-2.82,7.64-5.59a34.12,34.12,0,0,0,3.47-9.09l-5.86.87A21.69,21.69,0,0,0,260.89,359.43Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M235.74,435.87s-15.66-18.73-15.48-36.62h6.33s-6.87-4.52-6.33-7.05.72-12.11.72-12.11l5.79,1.45s-4.34-2.17-4.88-5.6,1.26-19.34,1.26-19.34,7,7.41,9.22,15,7.86,16.44,6.19,39.57S235.74,435.87,235.74,435.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.67,437.64s17-11.3,20.73-25.72l-5.08-1.38s6.51-2.13,6.63-4.28,2.06-9.89,2.06-9.89l-5-.11s4-.79,5.15-3.43S271.41,377,271.41,377s-7.29,4.41-10.69,10-9.92,11.5-13.63,30.46S243.67,437.64,243.67,437.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.43,372.94a4.31,4.31,0,0,1,.21.77c.13.55.31,1.29.52,2.22.45,1.93,1,4.73,1.7,8.2,1.35,6.95,2.93,16.61,4.18,27.34s1.89,20.5,2.17,27.57c.14,3.54.21,6.4.22,8.38v2.28a4.37,4.37,0,0,1,0,.79,6.13,6.13,0,0,1-.07-.79c0-.57-.06-1.33-.1-2.28-.07-2-.19-4.83-.38-8.36-.37-7.06-1.08-16.81-2.32-27.53s-2.77-20.37-4-27.33c-.62-3.48-1.15-6.29-1.54-8.23-.17-.94-.31-1.68-.42-2.24A4.19,4.19,0,0,1,227.43,372.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.56,447.35s-14.32-16.26-18.77-26.08l3.36-1.44a8.71,8.71,0,0,1-6.82-2.23,25.75,25.75,0,0,1-4.63-5.74l4.42-.75a16.45,16.45,0,0,1-9.66-7.48c5.22.85,9.94,3.72,13.83,7.31a69.46,69.46,0,0,1,8.39,9.71,33.19,33.19,0,0,1,3.25,5.35C229.34,431,233.57,441.38,233.56,447.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.63,386.47a4.61,4.61,0,0,1-.27.65l-.85,1.81c-.76,1.56-1.83,3.84-3.14,6.66-2.62,5.64-6.08,13.51-9.5,22.35s-6.15,17-8,22.94c-.93,3-1.66,5.37-2.16,7-.24.79-.44,1.43-.59,1.91a3,3,0,0,1-.24.66,4.24,4.24,0,0,1,.14-.68l.5-1.95c.43-1.68,1.11-4.11,2-7.09,1.77-6,4.45-14.15,7.87-23S257.33,401,260,395.43c1.35-2.8,2.48-5.05,3.29-6.59l.94-1.77A3.17,3.17,0,0,1,264.63,386.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.78,454.32a5.21,5.21,0,0,1-.25-1.16c-.13-.75-.32-1.83-.6-3.15A68.61,68.61,0,0,0,231,439.86a67.41,67.41,0,0,0-4.51-9.54c-.67-1.18-1.24-2.12-1.64-2.76a5,5,0,0,1-.57-1,4.84,4.84,0,0,1,.74.92c.46.61,1.07,1.52,1.79,2.68a56.28,56.28,0,0,1,7.48,19.81c.22,1.34.37,2.43.43,3.19A4.69,4.69,0,0,1,234.78,454.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.33,
    y: 450.49,
    width: 31.36,
    height: 6.4,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.32 456.89 228.71 478.4 247.66 478.4 250.82 456.89 225.32 456.89",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.76,456.89c0,.14-5.93.26-13.25.26s-13.25-.12-13.25-.26,5.94-.26,13.25-.26S251.76,456.74,251.76,456.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284,463.1c2.47-.57,5.45-3.8,6.46-6.13s1.54-4.88,2.75-7.12c1.61-3,4.35-5.23,5.65-8.33a20.62,20.62,0,0,0,1.07-7.71,44.68,44.68,0,0,0-7.54,4.7,14.93,14.93,0,0,0-5.06,7.15c-.6,2-.61,4.17-1.23,6.18s-1.69,3.62-2.37,5.5-.88,4.12.27,5.76",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284,463c2-3.68-1.23-6.34-2.34-7.66a23.51,23.51,0,0,1-3.27-4c-1.23-2.38-.88-5.33-2-7.76a9.26,9.26,0,0,0-5.8-4.57,27.24,27.24,0,0,0-7.54-.84c1,3,4.81,4,6.72,6.57,1.63,2.17,1.68,5.17,3,7.54,2.56,4.58,9.23,5.88,11.25,10.73",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.55,447.59c1.12-3.28,2.2-7,.73-10.11a10.49,10.49,0,0,1-1.4-3.19c-.15-1.38.67-2.65,1.16-4a9.15,9.15,0,0,0-1.43-8.89c-.22,2.11-1.94,3.69-3.52,5.09s-3.26,3.07-3.32,5.18c-.06,1.91,1.24,3.68,1.15,5.59s-1.42,3.32-2.26,4.95c-1.54,3-.91,8,.93,10.82l5.47,6.67C283.69,456.56,286.42,450.87,287.55,447.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.68,435.68a10.58,10.58,0,0,1-.49,1.14,16.28,16.28,0,0,1-1.9,2.82c-.9,1.11-2.09,2.34-3.35,3.75a16.47,16.47,0,0,0-3.31,5.1c-.71,2.05-.78,4.17-1.34,6a35.31,35.31,0,0,1-1.71,4.74,21.09,21.09,0,0,1-1.6,3,10.18,10.18,0,0,1-.72,1,1.76,1.76,0,0,1,.17-.27l.48-.78a26.73,26.73,0,0,0,1.54-3,35.29,35.29,0,0,0,1.65-4.74c.55-1.8.61-3.91,1.34-6a16.24,16.24,0,0,1,3.36-5.16c1.27-1.41,2.47-2.62,3.38-3.72a16.54,16.54,0,0,0,1.93-2.76c.21-.34.32-.63.42-.82S298.67,435.67,298.68,435.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.26,463.23a3.29,3.29,0,0,1-.41-.78,5.83,5.83,0,0,1-.31-2.39,13,13,0,0,1,.8-3.49,19.9,19.9,0,0,0,1.15-4.19c.15-1.52,0-3,.28-4.36a11.61,11.61,0,0,1,1.14-3.39,10.94,10.94,0,0,1,1.34-2,5.57,5.57,0,0,1,.61-.64s-.2.24-.55.69a13.52,13.52,0,0,0-1.27,2,12.17,12.17,0,0,0-1.08,3.36c-.25,1.32-.11,2.8-.27,4.36a18.82,18.82,0,0,1-1.17,4.22,13,13,0,0,0-.83,3.44,6,6,0,0,0,.24,2.35C284.11,463,284.28,463.22,284.26,463.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.83,458.2a1.93,1.93,0,0,1-.49-.23,6.72,6.72,0,0,1-1.21-.84,10.83,10.83,0,0,1-2.81-3.94,21.5,21.5,0,0,1-1.33-4.66c-.11-.61-.19-1.11-.24-1.45a3.34,3.34,0,0,1-.06-.54,2.71,2.71,0,0,1,.14.53c.09.46.2.93.3,1.43a25.68,25.68,0,0,0,1.38,4.61,11.33,11.33,0,0,0,2.71,3.91A14.31,14.31,0,0,0,283.83,458.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.78,422a7.82,7.82,0,0,1,0,1.47,11.87,11.87,0,0,1-1.06,3.87c-.34.78-.9,1.54-1.37,2.4a3.73,3.73,0,0,0-.44,1.43,3.92,3.92,0,0,0,.25,1.57,14.68,14.68,0,0,1,1.05,3.36,7.94,7.94,0,0,1-.81,3.7c-.51,1.19-1.1,2.31-1.5,3.45a13.17,13.17,0,0,0-.69,3.41,20.87,20.87,0,0,0,.5,5.88c.36,1.65.75,3,1,3.87l.3,1.05a3.25,3.25,0,0,1,.09.37s-.05-.12-.13-.36l-.34-1c-.28-.9-.7-2.21-1.07-3.86a20.64,20.64,0,0,1-.55-5.93,13.19,13.19,0,0,1,.69-3.46c.4-1.16,1-2.28,1.5-3.46a7.78,7.78,0,0,0,.79-3.6,13.78,13.78,0,0,0-1-3.32,4.22,4.22,0,0,1-.24-1.64,3.62,3.62,0,0,1,.47-1.5c.49-.88,1-1.61,1.39-2.39a12,12,0,0,0,1.11-3.81c.06-.47.07-.83.09-1.08A2.79,2.79,0,0,1,286.78,422Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.72,462a8.61,8.61,0,0,0-.38-1.2,9.08,9.08,0,0,0-2-2.79c-1-1-2.46-2-3.92-3.31a9.4,9.4,0,0,1-3.25-5.33,15,15,0,0,0-1.08-3,10.1,10.1,0,0,0-1.81-2.38,25,25,0,0,0-4.09-3.08c-1.23-.79-2.21-1.46-2.85-2a9.79,9.79,0,0,1-1-.83s.1.06.27.2l.75.57c.65.48,1.64,1.13,2.88,1.91a24.13,24.13,0,0,1,4.14,3.06,9.72,9.72,0,0,1,1.86,2.43,14.81,14.81,0,0,1,1.1,3.08,9.19,9.19,0,0,0,3.18,5.24c1.44,1.28,2.88,2.29,3.9,3.36a8.52,8.52,0,0,1,2,2.86A4.45,4.45,0,0,1,283.72,462Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.75,
    y: 456.62,
    width: 24.26,
    height: 4.95,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.06 461.56 276.69 478.21 291.35 478.21 293.79 461.56 274.06 461.56",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.52,461.56a97.24,97.24,0,0,1-10.25.27,97.24,97.24,0,0,1-10.25-.27c0-.14,4.59-.26,10.25-.26S294.52,461.42,294.52,461.56Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Earth--inject-244"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.52,100.66a1.87,1.87,0,0,1-.15.48c-.11.31-.31.75-.5,1.34a31.15,31.15,0,0,0,4.83,30.25,32.22,32.22,0,0,0,5.51,5.44,31.56,31.56,0,0,0,4.38,2.86c.54.31,1,.51,1.27.67s.44.23.43.25a3.17,3.17,0,0,1-.47-.18c-.29-.14-.75-.31-1.3-.6A28.43,28.43,0,0,1,281,138.4a31.29,31.29,0,0,1-10.42-13.74,31.29,31.29,0,0,1-1.39-17.18,29.11,29.11,0,0,1,1.49-5.06c.22-.58.44-1,.57-1.31A3.14,3.14,0,0,1,271.52,100.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.06,103.2a11.52,11.52,0,0,0,11.4,3.35c.8-.21,1.7-.67,1.79-1.5s-.78-1.53-1.58-1.89a13.57,13.57,0,0,0-10.8-.15,15.56,15.56,0,0,0,7.56-4.93c.75-.89,1.41-2.16.82-3.16s-1.95-1-3-.76a9.14,9.14,0,0,0-6.78,8.46,8.59,8.59,0,0,0-4.12-8.9c-1.16-.65-2.9-.89-3.63.23a2.8,2.8,0,0,0-.07,2.37,11,11,0,0,0,6.15,6.78,9.57,9.57,0,0,0-10.52.67,3.35,3.35,0,0,0-1.59,3c.27,1.48,2,2.15,3.54,2.26a12.58,12.58,0,0,0,10.1-4,7.16,7.16,0,0,0-1.26,6.54c.46,1.45,1.84,2.91,3.29,2.43s1.68-2.27,1.57-3.72a17.81,17.81,0,0,0-2.34-7.48",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.37,130.39a23.81,23.81,0,0,0,10.71-17c-1.52,0-2.83,1-3.87,2.14a24.6,24.6,0,0,0-6.56,14.63",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.16,104.76a41.36,41.36,0,0,0-4.39-1.2,37.54,37.54,0,0,0-4.55-.25,12.14,12.14,0,0,1,8.94,1.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.53,98.65a17.65,17.65,0,0,0-3.14,1.94c-1.55,1.34-2.46,2.78-2.57,2.7a7.76,7.76,0,0,1,2.31-3A6.05,6.05,0,0,1,275.53,98.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.39,97.88a6.61,6.61,0,0,1,2.93,2.14,5.66,5.66,0,0,1,1.56,3.27,17.53,17.53,0,0,0-1.87-3A33.54,33.54,0,0,0,265.39,97.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.11,103.05a1.48,1.48,0,0,1,.91-1.27,1.45,1.45,0,0,1,1.52.35,4.12,4.12,0,0,0-.74,1.06,6.07,6.07,0,0,0-1.69-.14",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.5,106.29a5.08,5.08,0,0,1,1.32-1,14.09,14.09,0,0,1,3.64-1.51,14.47,14.47,0,0,1,3.92-.48,4.74,4.74,0,0,1,1.62.21,20.28,20.28,0,0,0-10.5,2.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.34,105l-.23.22c-.16.15-.4.33-.69.61a20.8,20.8,0,0,0-4.87,6.68,19.68,19.68,0,0,0-1.67,5.82,20.31,20.31,0,0,0,1.67,10.78,20.56,20.56,0,0,0,1.62,2.93c.21.34.4.58.52.76l.17.27s-.08-.08-.22-.24-.33-.4-.55-.73a18,18,0,0,1-1.7-2.91,20.1,20.1,0,0,1-1.77-10.9,20.09,20.09,0,0,1,1.71-5.88,19.49,19.49,0,0,1,2.66-4.24,17.68,17.68,0,0,1,2.37-2.42c.29-.26.55-.44.71-.57A1.41,1.41,0,0,1,297.34,105Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.75,106a7.37,7.37,0,0,0,5.44,5.32,1.36,1.36,0,0,0,1.46-.31c.32-.46,0-1.1-.33-1.54a8.66,8.66,0,0,0-6.05-3.33,10,10,0,0,0,5.75-.51c.69-.28,1.44-.8,1.41-1.55s-.8-1.16-1.49-1.34a5.83,5.83,0,0,0-6.37,2.75,5.52,5.52,0,0,0,.34-6.27c-.46-.72-1.37-1.37-2.12-1a1.77,1.77,0,0,0-.75,1.32,7,7,0,0,0,1.44,5.68,6.14,6.14,0,0,0-6.15-2.79,2.17,2.17,0,0,0-1.8,1.23c-.3.92.5,1.83,1.32,2.34a8,8,0,0,0,6.92.76,4.57,4.57,0,0,0-2.67,3.31c-.18,1,.16,2.2,1.12,2.37s1.64-.78,2-1.64a11.25,11.25,0,0,0,.92-4.93",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.46,122.37a15.25,15.25,0,0,0,11.16-6.4,3.53,3.53,0,0,0-2.83,0,15.71,15.71,0,0,0-8.1,6.31",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.86,109.32a26,26,0,0,0-2.13-2,24.74,24.74,0,0,0-2.49-1.51,7.79,7.79,0,0,1,4.62,3.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.21,105.07a11.69,11.69,0,0,0-2.36.16c-1.28.29-2.23.83-2.26.75a4.94,4.94,0,0,1,2.2-1A4,4,0,0,1,300.21,105.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.71,101.6a4.2,4.2,0,0,1,1,2.08,3.58,3.58,0,0,1-.1,2.32,11.11,11.11,0,0,0-.15-2.26C295.19,102.52,294.63,101.64,294.71,101.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.69,105.34a.94.94,0,0,1,.9-.45.92.92,0,0,1,.75.65,2.82,2.82,0,0,0-.73.38,3.74,3.74,0,0,0-.92-.58",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.86,104.58a3,3,0,0,1,1-.15,8.84,8.84,0,0,1,2.51.24,9.16,9.16,0,0,1,2.36.91,2.73,2.73,0,0,1,.85.6,16.9,16.9,0,0,0-3.27-1.26A17.47,17.47,0,0,0,288.86,104.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.76,163.77c2-3,2-9.13.81-12.5s-3.07-6.49-3.95-10c-1.17-4.58-.51-9.54-2.14-14-1.26-3.45-3.79-6.26-6.26-9a63.32,63.32,0,0,0-3.28,12,21.16,21.16,0,0,0,1.6,12.21c1.32,2.65,3.36,4.88,4.64,7.54s1.72,5.35,2.81,7.94,3,5.1,5.77,5.69",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.66,144.34c-2-4.46-4.37-9.29-8.89-11.12-1.52-.62-3.25-.88-4.49-2-1.47-1.28-1.84-3.37-2.57-5.19a12.84,12.84,0,0,0-10-7.79c1.78,2.38,1.52,5.65,1.23,8.6s-.43,6.28,1.52,8.52c1.76,2,4.79,2.6,6.52,4.67s1.7,4.77,2.4,7.25c1.28,4.58,6.68,9.09,11.28,10.28l12,1.65C259.25,157.27,256.64,148.79,254.66,144.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.78,121.42a15.3,15.3,0,0,1,.56,1.66,22,22,0,0,1,.72,4.71c.14,2,.07,4.41.12,7.07a23,23,0,0,0,1.46,8.43c1.23,2.8,3.18,5.05,4.34,7.47a47,47,0,0,1,2.77,6.51,32,32,0,0,1,1.22,4.61,16.69,16.69,0,0,1,.24,1.73,4,4,0,0,1-.08-.45c-.05-.29-.13-.72-.24-1.27a33.93,33.93,0,0,0-1.28-4.58,49,49,0,0,0-2.8-6.46c-1.15-2.39-3.11-4.63-4.36-7.48a22.85,22.85,0,0,1-1.46-8.51c0-2.66,0-5.06-.08-7.06a22.66,22.66,0,0,0-.65-4.7c-.11-.55-.29-.95-.36-1.24A4,4,0,0,1,254.78,121.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.21,163.61a4.86,4.86,0,0,1-1.16-.44,8.19,8.19,0,0,1-2.59-2.17,18.13,18.13,0,0,1-2.5-4.36,27.8,27.8,0,0,0-2.81-5.42c-1.3-1.73-2.86-3.14-3.87-4.76a16.66,16.66,0,0,1-2.07-4.58,15.44,15.44,0,0,1-.54-3.34,7.87,7.87,0,0,1,0-1.24s0,.11,0,.32,0,.52.06.91a16.07,16.07,0,0,0,.61,3.31,16.25,16.25,0,0,0,2.08,4.51c1,1.6,2.56,3,3.88,4.75a27.08,27.08,0,0,1,2.82,5.46,18.42,18.42,0,0,0,2.43,4.34,8.54,8.54,0,0,0,2.52,2.2C265.79,163.47,266.22,163.58,266.21,163.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261,158.83a8.88,8.88,0,0,1-2.78.49,15.35,15.35,0,0,1-6.64-1.39,32,32,0,0,1-5.82-3.52c-.7-.52-1.25-.95-1.63-1.26l-.44-.35c-.1-.08-.15-.13-.14-.13l.17.1.45.32,1.68,1.2a35,35,0,0,0,5.82,3.45,15.84,15.84,0,0,0,6.55,1.43,12.62,12.62,0,0,0,2-.2A4.74,4.74,0,0,1,261,158.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.41,118.64a12.05,12.05,0,0,1,1.36,1.55,16.75,16.75,0,0,1,2.59,5c.39,1.13.54,2.45.87,3.79a5,5,0,0,0,.92,1.91,5.65,5.65,0,0,0,1.76,1.39c1.35.77,3,1.26,4.28,2.46a11.08,11.08,0,0,1,2.69,4.57c.61,1.71,1.07,3.43,1.75,5a18.17,18.17,0,0,0,2.55,4.18,29,29,0,0,0,6.14,5.58c1.94,1.37,3.6,2.34,4.74,3l1.32.78c.3.18.45.29.45.29s-.17-.08-.47-.25l-1.34-.75c-1.15-.67-2.83-1.63-4.79-3a28.83,28.83,0,0,1-6.2-5.58,18.35,18.35,0,0,1-2.59-4.22c-.69-1.58-1.15-3.3-1.76-5a10.8,10.8,0,0,0-2.63-4.49c-1.24-1.16-2.86-1.66-4.23-2.44A6,6,0,0,1,235,131a5.11,5.11,0,0,1-.94-2c-.34-1.37-.47-2.67-.86-3.79a17.16,17.16,0,0,0-2.5-5c-.39-.54-.73-.93-1-1.19A5.35,5.35,0,0,1,229.41,118.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.77,144.08c3.57.12,8.78-3.19,11-6s3.84-6.06,6.3-8.66c3.25-3.44,7.8-5.53,10.68-9.28,2.24-2.91,3.26-6.55,4.24-10.09a63.82,63.82,0,0,0-11.93,3.66,21.19,21.19,0,0,0-9.47,7.89c-1.53,2.52-2.33,5.44-3.89,8s-3.6,4.31-5.21,6.61-2.69,5.28-1.72,7.92",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.26,124.32c2.71-4,5.51-8.67,4.65-13.47-.3-1.61-1-3.21-.75-4.83.3-1.93,1.87-3.37,3-5a12.83,12.83,0,0,0,1.26-12.58c-1.05,2.77-4,4.3-6.61,5.63s-5.53,3-6.39,5.84c-.77,2.57.37,5.44-.46,8s-3.12,4-4.84,5.9c-3.19,3.53-4.12,10.51-2.66,15l5,11C455.78,135.11,461.55,128.36,464.26,124.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.69,112.16a14.28,14.28,0,0,1-1.1,1.36,21.84,21.84,0,0,1-3.6,3.13c-1.62,1.19-3.69,2.42-5.9,3.88a22.78,22.78,0,0,0-6.35,5.74c-1.71,2.53-2.57,5.39-4,7.66a48,48,0,0,1-4,5.82,34.9,34.9,0,0,1-3.24,3.5c-.84.76-1.34,1.12-1.34,1.12s.11-.11.33-.3l.95-.88a35.31,35.31,0,0,0,3.18-3.53,47.94,47.94,0,0,0,4-5.83c1.4-2.25,2.25-5.1,4-7.68a22.8,22.8,0,0,1,6.41-5.78c2.23-1.46,4.3-2.67,5.93-3.84a23.29,23.29,0,0,0,3.62-3.06c.41-.39.65-.76.86-1S483.69,112.16,483.69,112.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.15,144.37a4.68,4.68,0,0,1-.25-1.21,8.2,8.2,0,0,1,.45-3.35,18.14,18.14,0,0,1,2.35-4.44,27.54,27.54,0,0,0,3.07-5.27c.77-2,1.13-4.1,2-5.82a16.46,16.46,0,0,1,2.77-4.19,15.1,15.1,0,0,1,2.53-2.25,8.54,8.54,0,0,1,1.05-.67,1.72,1.72,0,0,1-.26.2c-.17.11-.43.29-.75.53a17.17,17.17,0,0,0-2.46,2.28,16.69,16.69,0,0,0-2.71,4.18c-.81,1.7-1.16,3.76-1.93,5.81a27.5,27.5,0,0,1-3.11,5.31,18.31,18.31,0,0,0-2.37,4.37,8.39,8.39,0,0,0-.51,3.3C454,143.94,454.18,144.37,454.15,144.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.38,137.38a8.94,8.94,0,0,1-1.9-2.09,15.18,15.18,0,0,1-2.37-6.35,31.17,31.17,0,0,1-.14-6.8c.07-.87.14-1.57.19-2l.06-.56c0-.13,0-.19,0-.19a.58.58,0,0,1,0,.19l0,.56c0,.61-.07,1.3-.12,2.06a34.79,34.79,0,0,0,.19,6.76,15.75,15.75,0,0,0,2.3,6.3,10.91,10.91,0,0,0,1.26,1.61A6.6,6.6,0,0,1,455.38,137.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.48,89.23a12,12,0,0,1-.58,2,16.7,16.7,0,0,1-2.85,4.85c-.74.94-1.78,1.77-2.73,2.77a5,5,0,0,0-1.12,1.79,5.93,5.93,0,0,0-.24,2.24c.08,1.54.54,3.2.21,4.93a11.11,11.11,0,0,1-2.42,4.71c-1.12,1.43-2.33,2.74-3.29,4.15A18.56,18.56,0,0,0,457.3,121a29.1,29.1,0,0,0-1.44,8.18c-.11,2.37-.05,4.3,0,5.63,0,.61,0,1.12,0,1.53s0,.53,0,.53,0-.18,0-.53,0-.91-.08-1.53c-.05-1.33-.14-3.26-.05-5.64a28.7,28.7,0,0,1,1.41-8.23,18.26,18.26,0,0,1,2.18-4.44c1-1.43,2.17-2.73,3.29-4.16a10.94,10.94,0,0,0,2.38-4.62c.32-1.67-.13-3.31-.2-4.88a5.94,5.94,0,0,1,.26-2.31,5.19,5.19,0,0,1,1.16-1.85c1-1,2-1.82,2.75-2.74a17.11,17.11,0,0,0,2.88-4.79,15.16,15.16,0,0,0,.5-1.45C472.42,89.41,472.48,89.23,472.48,89.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.65,134.09a1.64,1.64,0,0,1-.49-.11c-.31-.09-.77-.26-1.37-.4a31.37,31.37,0,0,0-34.79,13,32.54,32.54,0,0,0-2.52,4.59c-.27.56-.43,1-.57,1.31a4.26,4.26,0,0,1-.21.46,1.57,1.57,0,0,1,.14-.48c.11-.31.24-.78.49-1.35a29.24,29.24,0,0,1,2.43-4.68,30.55,30.55,0,0,1,22.09-14.11,30.61,30.61,0,0,1,7.83,0,28.48,28.48,0,0,1,5.16,1.1c.59.17,1,.36,1.35.47A2.43,2.43,0,0,1,507.65,134.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505,132.83a11.55,11.55,0,0,0-2.47,11.62c.28.78.8,1.64,1.63,1.67s1.47-.9,1.77-1.72a13.54,13.54,0,0,0-.68-10.78,15.64,15.64,0,0,0,5.49,7.17c.95.67,2.27,1.24,3.22.57s.87-2,.52-3.09a9.14,9.14,0,0,0-8.95-6.12,8.57,8.57,0,0,0,8.55-4.78c.57-1.21.67-3-.5-3.61a2.83,2.83,0,0,0-2.36.11,11,11,0,0,0-6.29,6.66,9.61,9.61,0,0,0-1.48-10.45,3.38,3.38,0,0,0-3.12-1.35c-1.46.39-2,2.19-2,3.7a12.59,12.59,0,0,0,4.8,9.77,7.15,7.15,0,0,0-6.62-.75c-1.41.56-2.76,2.05-2.17,3.46s2.39,1.5,3.83,1.28a17.83,17.83,0,0,0,7.28-2.9",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.15,138.21a23.87,23.87,0,0,0,17.78,9.38c-.07-1.52-1.24-2.75-2.42-3.7a24.69,24.69,0,0,0-15.1-5.42",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.07,141a37.75,37.75,0,0,0,.86-4.47,38.53,38.53,0,0,0-.09-4.55,12.1,12.1,0,0,1-.77,9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510,137.94a18.69,18.69,0,0,0-2.18-3c-1.45-1.44-3-2.24-2.89-2.36a7.89,7.89,0,0,1,3.17,2.07A6.13,6.13,0,0,1,510,137.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510,127.76a6.65,6.65,0,0,1-1.91,3.09,5.59,5.59,0,0,1-3.15,1.8,16.14,16.14,0,0,0,2.86-2.09A32.5,32.5,0,0,0,510,127.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505,130.88a1.41,1.41,0,0,1,1.11,2.35,4.23,4.23,0,0,0-1.12-.66,6,6,0,0,0,0-1.69",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.12,122.54a4.7,4.7,0,0,1,1.07,1.23,14.49,14.49,0,0,1,1.79,3.52,14.67,14.67,0,0,1,.77,3.87,4.72,4.72,0,0,1-.08,1.63,28.7,28.7,0,0,0-1.07-5.37A27.28,27.28,0,0,0,501.12,122.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.74,77.47a2.37,2.37,0,0,1,0,.45c0,.32,0,.74,0,1.27s0,1.22,0,2,0,1.68.1,2.66c.08,2,.27,4.3.57,6.89s.76,5.41,1.37,8.35,1.36,5.7,2.1,8.19,1.53,4.71,2.24,6.54c.34.93.69,1.75,1,2.47s.56,1.35.78,1.85l.5,1.17a2,2,0,0,1,.15.42,2.85,2.85,0,0,1-.21-.39l-.56-1.15c-.24-.49-.52-1.1-.83-1.83s-.67-1.53-1-2.45c-.74-1.83-1.53-4-2.32-6.54s-1.5-5.27-2.13-8.22-1-5.79-1.35-8.38-.45-4.94-.51-6.91c-.05-1,0-1.88,0-2.66s0-1.46,0-2,0-1,.05-1.27A2,2,0,0,1,410.74,77.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.51,91.81a7.42,7.42,0,0,1,1.77-4.65,1.77,1.77,0,0,1,1.46-.78c.77.11,1.11,1,1.14,1.8a5.45,5.45,0,0,1-1.22,3.59,4.59,4.59,0,0,1-3,1.83",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.19,101.12a12.47,12.47,0,0,1,1.72-6.72,2.22,2.22,0,0,1,.66-.67,1,1,0,0,1,.91-.09,1.37,1.37,0,0,1,.57,1.17,7.79,7.79,0,0,1-3.76,7.3",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.37,109.1a11.24,11.24,0,0,1,2.12-5.55,1.78,1.78,0,0,1,1.09-.82c.71-.09,1.27.63,1.42,1.32a5.49,5.49,0,0,1-1.21,4.1,14.87,14.87,0,0,1-2.73,2.71",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.33,114.71a11,11,0,0,1,1.92-4.37,2.38,2.38,0,0,1,.77-.68,1,1,0,0,1,1,0c.44.35.35,1,.16,1.57a9,9,0,0,1-3.29,4.49",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.46,112.45a35.35,35.35,0,0,0-5.67-3,1,1,0,0,0-1,0,.67.67,0,0,0-.21.7,1.78,1.78,0,0,0,.39.66,8.69,8.69,0,0,0,7,2.9",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.26,105l-4.66-3a4.16,4.16,0,0,0-1.42-.69,1.28,1.28,0,0,0-1.48,1.94,3.94,3.94,0,0,0,1.09,1.14,10.39,10.39,0,0,0,3.28,1.83,4.28,4.28,0,0,0,3.37,0",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.11,96.59a12.32,12.32,0,0,0-5-4,2,2,0,0,0-1-.24,1.57,1.57,0,0,0-1.21,1.58,2.93,2.93,0,0,0,1,2.13A6,6,0,0,0,408,97.22a14.24,14.24,0,0,0,4.39.84",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.12,88.77a14.43,14.43,0,0,0-5-5.34,1.53,1.53,0,0,0-1.47-.37,1,1,0,0,0-.51.83,2.43,2.43,0,0,0,.17,1,7.7,7.7,0,0,0,6.85,5.06",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.87,84.7a20.06,20.06,0,0,1-1.29-3.65,6.76,6.76,0,0,1,.14-3.81,3,3,0,0,1,.91-1.36,1.62,1.62,0,0,1,1.56-.28,1.75,1.75,0,0,1,.94,1.16,4.37,4.37,0,0,1,.06,1.53c-.21,2.44-.95,5.31-2.32,6.41",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.58,74l0,.13c0,.1-.06.22-.11.37-.1.35-.25.82-.44,1.42s-.44,1.37-.68,2.26-.57,1.88-.84,3-.62,2.34-.91,3.67-.6,2.74-.9,4.24c-.56,3-1.07,6.32-1.42,9.83s-.5,6.86-.55,9.91c0,1.53,0,3,0,4.34s.1,2.62.17,3.78.16,2.19.23,3.1.15,1.71.22,2.35.12,1.12.16,1.48c0,.16,0,.28,0,.39s0,.13,0,.13l0-.13c0-.1,0-.23-.06-.38,0-.36-.12-.86-.2-1.48s-.19-1.43-.27-2.34-.21-2-.28-3.11-.16-2.42-.19-3.78-.06-2.82-.07-4.35c0-3.06.18-6.42.52-9.94s.88-6.84,1.45-9.85c.32-1.5.6-2.93.93-4.25s.63-2.55.94-3.66.62-2.12.88-3,.51-1.63.73-2.24.37-1.06.49-1.41l.14-.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.38,90.32A8.63,8.63,0,0,1,435,85.75a2.07,2.07,0,0,1,1.91-.36c.81.4.88,1.54.64,2.41a6.36,6.36,0,0,1-2.64,3.59,5.35,5.35,0,0,1-4,1",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430,101.33a14.57,14.57,0,0,1,4.3-6.91,2.73,2.73,0,0,1,1-.52,1.13,1.13,0,0,1,1,.22,1.6,1.6,0,0,1,.24,1.51,9.17,9.17,0,0,1-6.8,6.84",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.57,111a13.3,13.3,0,0,1,4.34-5.45,2,2,0,0,1,1.51-.54c.82.15,1.2,1.15,1.13,2-.15,1.71-1.46,3.09-2.82,4.15a17.17,17.17,0,0,1-4,2.06",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.79,118a12.85,12.85,0,0,1,3.69-4.2,2.72,2.72,0,0,1,1.11-.5,1.13,1.13,0,0,1,1.08.42c.37.54,0,1.28-.37,1.8a10.53,10.53,0,0,1-5.27,3.86",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.61,115.16a40.6,40.6,0,0,0-5.28-5.37,1.17,1.17,0,0,0-1.05-.4.77.77,0,0,0-.48.71,2,2,0,0,0,.2.88,10.2,10.2,0,0,0,6.79,5.71",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.78,106.09c-1.38-1.68-2.76-3.37-4.15-5a5.1,5.1,0,0,0-1.34-1.28,1.73,1.73,0,0,0-1.77,0,1.68,1.68,0,0,0-.57,1.67,4.59,4.59,0,0,0,.81,1.66,12.48,12.48,0,0,0,3,3.21,5.08,5.08,0,0,0,3.79,1.17",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.35,95.88a14.44,14.44,0,0,0-4.17-6.26A2.43,2.43,0,0,0,425.1,89a1.82,1.82,0,0,0-1.9,1.33,3.42,3.42,0,0,0,.37,2.75,7.5,7.5,0,0,0,1.95,2.06,17,17,0,0,0,4.61,2.49",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432,86.78c-.4-2.93-1.93-5.37-3.69-7.74-.37-.5-.89-1-1.51-.93a1.22,1.22,0,0,0-.87.74,2.89,2.89,0,0,0-.16,1.17,9,9,0,0,0,5.87,8.08",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.17,82.13A24.49,24.49,0,0,1,433,77.6a8.09,8.09,0,0,1,1.5-4.21,3.46,3.46,0,0,1,1.51-1.2,1.87,1.87,0,0,1,1.84.24,2,2,0,0,1,.64,1.63,5.3,5.3,0,0,1-.47,1.73c-1.11,2.66-3,5.6-4.87,6.34",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.45,88.58a2.2,2.2,0,0,1,0,.45l-.08,1.26c0,.55-.09,1.23-.18,2s-.17,1.66-.32,2.64c-.26,2-.67,4.27-1.22,6.82s-1.29,5.33-2.2,8.2-2,5.55-3,8-2.05,4.52-3,6.26c-.44.88-.89,1.65-1.27,2.34s-.72,1.26-1,1.73l-.67,1.08a3.23,3.23,0,0,1-.25.37,2.61,2.61,0,0,1,.19-.4l.62-1.11c.27-.48.6-1.07,1-1.76s.8-1.47,1.23-2.36c.9-1.75,1.88-3.88,2.9-6.27s2-5.08,2.94-7.94,1.63-5.63,2.22-8.16,1-4.85,1.28-6.79c.16-1,.26-1.86.37-2.64s.18-1.44.23-2,.11-.94.15-1.26A3.16,3.16,0,0,1,449.45,88.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.21,102.76a7.44,7.44,0,0,0-1.28-4.8,1.77,1.77,0,0,0-1.38-.93c-.77,0-1.21.91-1.32,1.67a5.44,5.44,0,0,0,.85,3.7,4.56,4.56,0,0,0,2.75,2.12",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.58,111.85a12.38,12.38,0,0,0-1-6.86,2.38,2.38,0,0,0-.59-.74,1,1,0,0,0-.89-.18,1.38,1.38,0,0,0-.7,1.1,7.81,7.81,0,0,0,3,7.65",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.59,119.56a11.32,11.32,0,0,0-1.54-5.73,1.77,1.77,0,0,0-1-.94c-.69-.16-1.32.5-1.55,1.18a5.43,5.43,0,0,0,.79,4.2,14.84,14.84,0,0,0,2.44,3",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.06,124.94a11.13,11.13,0,0,0-1.46-4.54,2.32,2.32,0,0,0-.7-.76,1,1,0,0,0-1,0c-.47.3-.45,1-.31,1.54a9,9,0,0,0,2.8,4.81",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.16,122.79a34.52,34.52,0,0,1,5.95-2.42,1,1,0,0,1,1,0,.67.67,0,0,1,.13.72,1.71,1.71,0,0,1-.45.62,8.71,8.71,0,0,1-7.25,2.16",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.11,115.64l4.95-2.55a4.27,4.27,0,0,1,1.48-.54,1.45,1.45,0,0,1,1.39.58,1.41,1.41,0,0,1-.12,1.5,3.7,3.7,0,0,1-1.19,1,10.55,10.55,0,0,1-3.45,1.48,4.34,4.34,0,0,1-3.36-.37",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.12,107.46A12.28,12.28,0,0,1,451.5,104a2.08,2.08,0,0,1,1.07-.13,1.56,1.56,0,0,1,1,1.69,2.91,2.91,0,0,1-1.23,2,6.28,6.28,0,0,1-2.22,1,14.18,14.18,0,0,1-4.45.38",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.91,99.78a14.56,14.56,0,0,1,5.51-4.8,1.54,1.54,0,0,1,1.5-.22,1,1,0,0,1,.42.88,2.24,2.24,0,0,1-.27,1,7.73,7.73,0,0,1-7.33,4.33",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.58,95.75a20.6,20.6,0,0,0,1.65-3.49,6.88,6.88,0,0,0,.26-3.81,3.1,3.1,0,0,0-.77-1.45,1.61,1.61,0,0,0-1.53-.43,1.71,1.71,0,0,0-1,1.06,4.3,4.3,0,0,0-.23,1.51c0,2.45.41,5.38,1.66,6.61",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519,244.52c-.16-1.72-.35-3.42-.58-5.13s-.49-3.59-.79-5.36q.45,2.66.79,5.36C518.61,241.1,518.8,242.8,519,244.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.46,265.79c-1.46-3.36-1.79-7.07-2.76-10.6-.52-1.89-1.39-3.91-3.13-4.74-1.15-.56-2.52-.48-3.74-.87-4.4-1.34-5.6-7.6-9.77-9.54a13.87,13.87,0,0,0-4.19-.89c-5.57-.67-11.34-2.63-14.85-7.09-1.15-1.44-2-3.15-3.43-4.32s-3.65-1.68-5-.48c1.18,2.4,2.33,4.8,3.48,7.17a19,19,0,0,0,3.91,6c1.79,1.61,4.42,2.45,6.57,1.44a4.18,4.18,0,0,1,2.21-.79,2.38,2.38,0,0,1,1.43.93c3,3.43,2.05,9.11-.91,12.61s-7.32,5.3-11.54,7a8.74,8.74,0,0,1-4.7.93c-2.92-.55-4.47-3.79-5.32-6.69-1.91-6.43-2.83-13.4-6.73-18.82-1.25-1.7-2.8-3.26-3.56-5.25-.8-2.16-.61-4.68-1.88-6.57s-4.12-3.14-4.31-5.54c-.11-1.68,1.25-3.17,2.76-3.89s3.2-1,4.75-1.6c.61-.27,1.3-.72,1.32-1.39,0-1-1.37-1.42-1.72-2.35s.68-2,1.13-3.07c1-2.35-1.43-4.73-3.76-5.68s-5.11-1.66-6.19-4a13.65,13.65,0,0,1-.76-3.43c-.54-2.9-2.63-5.71-5.5-6.19s-6.1,2.14-5.63,5.06c.28,1.61,1.46,2.86,2.1,4.34s.47,3.7-1,4.18c-2.47.76-4.85-3.84-6.92-2.26.85,3,1.67,5.9,2.52,8.87-3.25,1.68-7.13-1.36-8.52-4.82s-1.44-7.36-3.08-10.67-6.1-5.8-8.92-3.45c-.15,4.27,5.39,6,7.83,9.45,1.77,2.49,1.51,6.54-1.1,8.13s-6.71-1.18-5.72-4.08c.35-1,1.17-1.85,1.27-2.92.09-1.35-1-2.43-2-3.29-1.57-1.37-3.15-2.71-4.73-4a9.72,9.72,0,0,0-3.36-2.16c-3.25-1-6.5,1.73-8.21,4.68s-2.69,6.45-5.06,8.92c-3.42,3.59-9.89,3.81-13.09,0s-1.58-10.81,3.15-12.18c1.79-.5,4.05-.45,5-2.06,1.65-2.85-3.06-6.5-1.43-9.37,1.24-2.21,4.54-1.2,6.94-2s3.72-3.19,5.13-5.3,3.58-4.19,6-3.64a7.84,7.84,0,0,1,.25-4.36c.64-1.35,2.43-2.21,3.61-1.35-1.2,2,.23,4.82,2.33,5.83s4.54.77,6.84.5,5.21-1.15,5.39-3.5a8.39,8.39,0,0,1,.07-2.3c1-2.8,6.1,1.06,8.05-1.2,1.13-1.17-.11-3.26-1.69-3.64s-3.18.19-4.78.24-3.55-.79-3.62-2.42,1.69-2.76,1.88-4.34c.31-2.69-4.17-3.39-5.74-1.2s-1,5.18-.54,7.84.73,5.8-1.2,7.67c-.83,1.27-3,.6-3.68-.74s-.56-3-.68-4.49-.78-3.26-2.23-3.67c-1-.28-2.1.22-3.13.36-4.1.51-7-4.89-5.65-8.87s5-6.57,8.59-8.61c2.63-1.48,5.9-2.87,8.52-1.36,1.22.69,2.07,1.89,3.27,2.61,2.07,1.25,4.63.79,7,.84a16.22,16.22,0,0,1,10.24,4.05c1.06,1,2.05,2.62,1.22,3.79s-3.46,1.51-3,3a5.09,5.09,0,0,0,6.4-4.19,4.33,4.33,0,0,1,2.47,3.55,7.52,7.52,0,0,1,11.18.93,9.8,9.8,0,0,0,2.07,2.71c.95.62,2.59.31,2.71-.81a2.29,2.29,0,0,0-.19-1.06c-.56-1.63-1.15-3.24-1.72-4.84,2.19-1.2,4.78.67,6.26,2.68,5.51,7.51,9.44,3,17.21,4.22,5.25.82,7.55,4.25,10.52,8.4,9.08,12.75,21.09,23.21,29.35,36.54.87,1.39,1.67,2.8,2.42,4.24-.14-.36-.26-.72-.4-1.08a149.15,149.15,0,0,0-12-24.86q-1.51-2.52-3.11-5c-.66-1-1.34-2-2-3-.87-1.29-1.79-2.54-2.71-3.79-.73-1-1.46-2-2.21-3-.52-.67-1.06-1.34-1.6-2s-1.18-1.51-1.84-2.25l-2-2.33a8.28,8.28,0,0,0-.64-.72c-.68-.81-1.41-1.6-2.14-2.4a.93.93,0,0,0-.21-.24c-.19-.21-.4-.43-.62-.64-.58-.67-1.22-1.32-1.83-2-1-1.05-2.05-2.11-3.11-3.12-.87-.88-1.76-1.72-2.68-2.56s-1.6-1.49-2.42-2.21-1.61-1.41-2.43-2.11c-1-.86-2-1.7-3-2.54h0q-4.28-3.49-8.8-6.59c-.75-.53-1.48-1-2.24-1.54s-1.53-1-2.28-1.48-1.53-1-2.31-1.44-1.55-1-2.33-1.42c-.63-.38-1.24-.74-1.88-1.08-.33-.21-.63-.38-1-.55-1.34-.77-2.71-1.51-4.08-2.2-.68-.36-1.36-.72-2.07-1.06-.87-.45-1.76-.89-2.66-1.29a1.5,1.5,0,0,0-.4-.2c-.8-.38-1.6-.76-2.42-1.12-1.15-.51-2.31-1-3.46-1.49-1.32-.55-2.64-1.1-4-1.61s-3-1.12-4.47-1.63-3-1-4.56-1.51-3.06-.91-4.62-1.34q-4.59-1.26-9.29-2.23a1.09,1.09,0,0,1-.17-.05c-1.2-.24-2.4-.48-3.6-.67a1.2,1.2,0,0,0-.23,0c-.52-.09-1.06-.19-1.6-.26q-3.36-.57-6.78-1c-.26,0-.54-.07-.83-.1-.66-.09-1.31-.14-2-.21-1.5-.15-3-.27-4.54-.36s-3.18-.19-4.78-.24-3.34-.1-5-.1c-4.42,0-8.8.19-13.13.6-1,.07-2.05.17-3.06.29s-2.12.24-3.18.38-2.12.29-3.15.46-2.1.34-3.16.53c-.89.14-1.81.31-2.7.5-2.22.43-4.4.91-6.57,1.44-1,.24-2,.5-3,.79s-2,.55-3,.84c-1.67.48-3.29,1-4.92,1.53h0l-3.95,1.37a.14.14,0,0,0-.1,0c-1.34.48-2.63,1-3.95,1.51l-.21.07c-1.2.48-2.41,1-3.58,1.49-1.48.62-2.94,1.29-4.38,2-1.22.58-2.42,1.16-3.6,1.75s-2.54,1.3-3.79,2l-.14.07c-1.2.65-2.4,1.32-3.58,2s-2.42,1.41-3.62,2.18h0c-1.13.69-2.23,1.39-3.34,2.11-.42.26-.82.55-1.24.84-1.18.77-2.31,1.56-3.46,2.37-1.42,1-2.78,2-4.15,3.05-1.2.91-2.37,1.84-3.53,2.78a150.13,150.13,0,0,0-18.5,17.86c-2,2.26-3.88,4.56-5.71,6.91-1.56,2-3.06,4.05-4.5,6.16q-1.94,2.75-3.75,5.6,1.81-2.85,3.75-5.6c.38,0,.75-.1,1.13-.12,2.12-.17,4.35-.1,6.26-1s3-2.5,4.61-3.65c4.1-3,10.81-3.52,11.91-8.51.38-1.68-.07-3.5.54-5.11,1.16-3,5.09-3.42,8.24-3.38,1.34,0,2.92.2,3.53,1.39a3.49,3.49,0,0,1-.14,2.79A26,26,0,0,1,275,167.82c-4.1,2.54-9.44,4.51-10.57,9.25.56,1.61,3.44,1.49,3.67,3.17.17,1.34-1.53,2-2.14,3.24-.9,1.75,1.15,3.88,3.11,3.78s3.57-1.53,5-2.87c4.28-4,8.78-8.42,10.33-14.17.66-2.38.9-5.16,2.78-6.74a4.57,4.57,0,0,1,7,2.28c1.86-1.06,4.75-1.85,5.72.12a10.5,10.5,0,0,1,.4,2.25c.61,3.07,4.73,4.46,5.15,7.55.5,3.58-4,5.42-7.51,6-3.17.51-6.35,1-9.53,1.54a8.6,8.6,0,0,0-3.95,1.29,3.19,3.19,0,0,0-1.18,3.77,9.57,9.57,0,0,0,1.65,1.72c2.63,2.69.47,8.23-3.25,8.35-1.27.05-2.52-.43-3.79-.48-3.76-.17-6.75,3.21-8.54,6.59s-3.13,7.24-6.14,9.55c-4.85,3.71-13.21,2.85-15.56,8.56-.94,2.3-.45,4.89-.07,7.36s.54,5.18-.87,7.21-5,2.45-6.05.2a5.58,5.58,0,0,1-.14-3.19c.56-3.55,1.1-7.1,1.65-10.65.4-2.64.75-5.59-.78-7.74-2.14-3-6.94-2.74-9.72-.32s-3.91,6.21-4.68,9.84c-.57,2.68-1.23,6.47-2.69,9.54h0c-.49,3-.89,6-1.2,9s-.52,6.21-.63,9.37a13.74,13.74,0,0,0,1.2-1.15c1.48-1.56,4.47-8.15,7.15-4.91a2.47,2.47,0,0,1,0,3c-.83,1.08-2.47,1.32-3.11,2.5-.77,1.39.31,3.11,1.58,4s2.82,1.51,3.72,2.83c1.72,2.51.07,6.33,1.74,8.89,1.43,2.21,4.49,2.35,7.11,2.64l.89.14c.73-5.27,3.15-9.56,10.21-11.19,9.75-2.26,22.55,6,28,13.45,6.12,8.36,9,20.21,18.39,24.41,6.7,3,16.24,1.91,19.51,8.6,2.92,6-2.17,12.74-2.95,19.38-.49,4.39.92,8.75,1.25,13.14s-1,9.54-4.89,11.39c-2.19,1-4.95.88-6.71,2.56-3.13,3-.57,9.26-3.7,12.28-1.1,1.05-2.63,1.44-4,2.13-7,3.62-6.85,14.17-3.58,21.49l.35.76a146.38,146.38,0,0,0,146.06,3.77h0a151.1,151.1,0,0,0,31.64-23,147.49,147.49,0,0,0,11.29-12c2.5-2.92,4.85-6,7.11-9.08,1.15-1.61,2.28-3.22,3.34-4.87a149.4,149.4,0,0,0,18.5-38.77,149.78,149.78,0,0,0,5.67-25.68q.67-5.12,1-10.34a8.48,8.48,0,0,1-6,2.71C509.83,272.19,506.89,269.15,505.46,265.79Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.72,299.36c-.47-4.34.94-8.68,1-13.07.05-3-.16-6.21-.21-9.25A40.06,40.06,0,0,1,235,276a2.24,2.24,0,0,1-1.39-.72,2.93,2.93,0,0,1-.31-1.61c-.19-3.4-3.41-5.66-6.3-7.36a24.94,24.94,0,0,0-4.59-2.3c0,.36,0,.69,0,1a153.43,153.43,0,0,0,9.46,48.08A145.4,145.4,0,0,0,241,333c1.45,2.76,3.05,5.47,4.73,8.13,2.07,3.29,4.23,6.5,6.56,9.59,2.17,3,4.47,5.88,6.9,8.66a148,148,0,0,0,10.52,11q4.9,4.67,10.24,8.87c-8.12-22.2-15.77-44.86-29.66-63.76C246.59,310.53,242.4,305.5,241.72,299.36Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.35,256.8c0,.91,0,1.82,0,2.73,0,.75,0,1.48,0,2.22,0-.74,0-1.47,0-2.22C222.31,258.62,222.34,257.71,222.35,256.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.22,385.37c1.25.86,2.51,1.7,3.8,2.52.89.57,1.78,1.12,2.7,1.67-.92-.55-1.81-1.1-2.7-1.67C290.73,387.07,289.47,386.23,288.22,385.37Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.45,253.23v0h0v0a7.73,7.73,0,0,0,0,.84c0,.9,0,1.82-.05,2.73,0-.91,0-1.83.05-2.73A7.73,7.73,0,0,1,222.45,253.23Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.34,261.75c0,.74,0,1.49,0,2.22h0C222.35,263.24,222.35,262.49,222.34,261.75Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M242.78,271.16l-.89-.14c-2.62-.29-5.68-.43-7.11-2.64-1.67-2.56,0-6.38-1.74-8.89-.9-1.32-2.45-1.9-3.72-2.83s-2.35-2.64-1.58-4c.64-1.18,2.28-1.42,3.11-2.5a2.47,2.47,0,0,0,0-3c-2.68-3.24-5.67,3.35-7.15,4.91a13.74,13.74,0,0,1-1.2,1.15v0a7.73,7.73,0,0,0,0,.84c0,.9,0,1.82-.05,2.73s0,1.82,0,2.73c0,.75,0,1.48,0,2.22s0,1.49,0,2.22a24.94,24.94,0,0,1,4.59,2.3c2.89,1.7,6.11,4,6.3,7.36a2.93,2.93,0,0,0,.31,1.61A2.24,2.24,0,0,0,235,276a40.06,40.06,0,0,0,7.55,1.08",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.52,277c0,3,.26,6.23.21,9.25-.07,4.39-1.48,8.73-1,13.07.68,6.14,4.87,11.17,8.52,16.11,13.89,18.9,21.54,41.56,29.66,63.76h0c1.51,1.22,3,2.37,4.59,3.5q1.83,1.35,3.71,2.64c1.25.86,2.51,1.7,3.8,2.52.89.57,1.78,1.12,2.7,1.67l-.35-.76c-3.27-7.32-3.46-17.87,3.58-21.49,1.34-.69,2.87-1.08,4-2.13,3.13-3,.57-9.26,3.7-12.28,1.76-1.68,4.52-1.56,6.71-2.56,3.93-1.85,5.2-7,4.89-11.39s-1.74-8.75-1.25-13.14c.78-6.64,5.87-13.38,2.95-19.38-3.27-6.69-12.81-5.61-19.51-8.6-9.37-4.2-12.27-16.05-18.39-24.41-5.48-7.48-18.28-15.71-28-13.45-7.06,1.63-9.48,5.92-10.21,11.19",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.65,215.41c2.78-2.42,7.58-2.71,9.72.32,1.53,2.15,1.18,5.1.78,7.74-.55,3.55-1.09,7.1-1.65,10.65a5.58,5.58,0,0,0,.14,3.19c1,2.25,4.66,1.82,6.05-.2s1.24-4.77.87-7.21-.87-5.06.07-7.36c2.35-5.71,10.71-4.85,15.56-8.56,3-2.31,4.35-6.17,6.14-9.55s4.78-6.76,8.54-6.59c1.27,0,2.52.53,3.79.48,3.72-.12,5.88-5.66,3.25-8.35a9.57,9.57,0,0,1-1.65-1.72,3.19,3.19,0,0,1,1.18-3.77,8.6,8.6,0,0,1,3.95-1.29c3.18-.53,6.36-1,9.53-1.54,3.51-.55,8-2.39,7.51-6-.42-3.09-4.54-4.48-5.15-7.55a10.5,10.5,0,0,0-.4-2.25c-1-2-3.86-1.18-5.72-.12a4.57,4.57,0,0,0-7-2.28c-1.88,1.58-2.12,4.36-2.78,6.74-1.55,5.75-6.05,10.12-10.33,14.17-1.44,1.34-3.06,2.78-5,2.87s-4-2-3.11-3.78c.61-1.2,2.31-1.9,2.14-3.24-.23-1.68-3.11-1.56-3.67-3.17,1.13-4.74,6.47-6.71,10.57-9.25a26,26,0,0,0,10.8-13.52,3.49,3.49,0,0,0,.14-2.79c-.61-1.19-2.19-1.39-3.53-1.39-3.15,0-7.08.39-8.24,3.38-.61,1.61-.16,3.43-.54,5.11-1.1,5-7.81,5.54-11.91,8.51-1.6,1.15-2.84,2.76-4.61,3.65s-4.14.86-6.26,1c-.38,0-.75.07-1.13.12q-1.94,2.75-3.75,5.6t-3.48,5.79a151.05,151.05,0,0,0-12.89,29.3c-1.16,3.58-2.17,7.23-3.06,10.93s-1.63,7.45-2.24,11.25c1.46-3.07,2.12-6.86,2.69-9.54C227.74,221.62,228.89,217.84,231.65,215.41Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M519.65,257.45c0-2.18-.08-4.35-.19-6.5.11,2.15.18,4.32.19,6.5,0,.69,0,1.39,0,2.08,0,3.36-.11,6.67-.3,10,.19-3.31.3-6.62.3-10C519.69,258.84,519.69,258.14,519.65,257.45Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M510.35,206.62c.71,1.91,1.37,3.84,2,5.79-.63-1.95-1.29-3.88-2-5.79,0,0,0,0,0,0h0Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M519.65,257.45c0-2.18-.08-4.35-.19-6.5s-.28-4.29-.5-6.43c-.16-1.72-.35-3.42-.58-5.13s-.49-3.59-.79-5.36a149.93,149.93,0,0,0-3.47-15.74c-.56-2-1.14-3.94-1.77-5.88s-1.29-3.88-2-5.79v0h0c-.75-1.44-1.55-2.85-2.42-4.24-8.26-13.33-20.27-23.79-29.35-36.54-3-4.15-5.27-7.58-10.52-8.4-7.77-1.22-11.7,3.29-17.21-4.22-1.48-2-4.07-3.88-6.26-2.68.57,1.6,1.16,3.21,1.72,4.84a2.29,2.29,0,0,1,.19,1.06c-.12,1.12-1.76,1.43-2.71.81a9.8,9.8,0,0,1-2.07-2.71,7.52,7.52,0,0,0-11.18-.93,4.33,4.33,0,0,0-2.47-3.55,5.09,5.09,0,0,1-6.4,4.19c-.45-1.46,2.12-1.72,3-3s-.16-2.8-1.22-3.79a16.22,16.22,0,0,0-10.24-4.05c-2.38,0-4.94.41-7-.84-1.2-.72-2-1.92-3.27-2.61-2.62-1.51-5.89-.12-8.52,1.36-3.6,2-7.32,4.61-8.59,8.61s1.55,9.38,5.65,8.87c1-.14,2.11-.64,3.13-.36,1.45.41,2.11,2.14,2.23,3.67s0,3.14.68,4.49,2.85,2,3.68.74c1.93-1.87,1.69-5,1.2-7.67s-1-5.66.54-7.84,6.05-1.49,5.74,1.2c-.19,1.58-1.95,2.73-1.88,4.34s2,2.49,3.62,2.42,3.23-.65,4.78-.24,2.82,2.47,1.69,3.64c-1.95,2.26-7-1.6-8.05,1.2a8.39,8.39,0,0,0-.07,2.3c-.18,2.35-3.08,3.22-5.39,3.5s-4.75.51-6.84-.5-3.53-3.81-2.33-5.83c-1.18-.86-3,0-3.61,1.35a7.84,7.84,0,0,0-.25,4.36c-2.45-.55-4.64,1.56-6,3.64s-2.75,4.56-5.13,5.3-5.7-.26-6.94,2c-1.63,2.87,3.08,6.52,1.43,9.37-.94,1.61-3.2,1.56-5,2.06-4.73,1.37-6.37,8.42-3.15,12.18s9.67,3.55,13.09,0c2.37-2.47,3.34-5.95,5.06-8.92s5-5.64,8.21-4.68a9.72,9.72,0,0,1,3.36,2.16c1.58,1.34,3.16,2.68,4.73,4,1,.86,2.12,1.94,2,3.29-.1,1.07-.92,1.91-1.27,2.92-1,2.9,3.13,5.66,5.72,4.08s2.87-5.64,1.1-8.13c-2.44-3.45-8-5.18-7.83-9.45,2.82-2.35,7.27.12,8.92,3.45s1.69,7.25,3.08,10.67,5.27,6.5,8.52,4.82c-.85-3-1.67-5.92-2.52-8.87,2.07-1.58,4.45,3,6.92,2.26,1.51-.48,1.69-2.69,1-4.18s-1.82-2.73-2.1-4.34c-.47-2.92,2.73-5.54,5.63-5.06s5,3.29,5.5,6.19a13.65,13.65,0,0,0,.76,3.43c1.08,2.3,3.88,3,6.19,4s4.73,3.33,3.76,5.68c-.45,1-1.5,2-1.13,3.07s1.72,1.34,1.72,2.35c0,.67-.71,1.12-1.32,1.39-1.55.65-3.25.86-4.75,1.6s-2.87,2.21-2.76,3.89c.19,2.4,3,3.55,4.31,5.54s1.08,4.41,1.88,6.57c.76,2,2.31,3.55,3.56,5.25,3.9,5.42,4.82,12.39,6.73,18.82.85,2.9,2.4,6.14,5.32,6.69a8.74,8.74,0,0,0,4.7-.93c4.22-1.71,8.59-3.53,11.54-7s3.95-9.18.91-12.61a2.38,2.38,0,0,0-1.43-.93,4.18,4.18,0,0,0-2.21.79c-2.15,1-4.78.17-6.57-1.44a19,19,0,0,1-3.91-6c-1.15-2.37-2.3-4.77-3.48-7.17,1.39-1.2,3.6-.7,5,.48s2.28,2.88,3.43,4.32c3.51,4.46,9.28,6.42,14.85,7.09a13.87,13.87,0,0,1,4.19.89c4.17,1.94,5.37,8.2,9.77,9.54,1.22.39,2.59.31,3.74.87,1.74.83,2.61,2.85,3.13,4.74,1,3.53,1.3,7.24,2.76,10.6s4.37,6.4,7.95,6.45a8.48,8.48,0,0,0,6-2.71v0c.19-3.31.3-6.62.3-10C519.69,258.84,519.69,258.14,519.65,257.45Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M279.9,379.23h0c1.51,1.22,3,2.37,4.59,3.5q1.83,1.35,3.71,2.64c1.25.86,2.51,1.7,3.8,2.52.89.57,1.78,1.12,2.7,1.67l-.35-.76c-3.27-7.32-3.46-17.87,3.58-21.49,1.34-.69,2.87-1.08,4-2.13,3.13-3,.57-9.26,3.7-12.28,1.76-1.68,4.52-1.56,6.71-2.56,3.93-1.85,5.2-7,4.89-11.39s-1.74-8.75-1.25-13.14c.78-6.64,5.87-13.38,2.95-19.38-3.27-6.69-12.81-5.61-19.51-8.6-9.37-4.2-12.27-16.05-18.39-24.41-5.48-7.48-18.28-15.71-28-13.45-7.06,1.63-9.48,5.92-10.21,11.19l-.89-.14c-2.62-.29-5.68-.43-7.11-2.64-1.67-2.56,0-6.38-1.74-8.89-.9-1.32-2.45-1.9-3.72-2.83s-2.36-2.64-1.58-4c.64-1.18,2.28-1.42,3.11-2.5a2.47,2.47,0,0,0,0-3c-2.68-3.24-5.67,3.35-7.15,4.91a13.74,13.74,0,0,1-1.2,1.15v0a7.73,7.73,0,0,0,0,.84c0,.9,0,1.82-.05,2.73s0,1.82,0,2.73c0,.75,0,1.48,0,2.22s0,1.49,0,2.22c0,.36,0,.69,0,1a153.43,153.43,0,0,0,9.46,48.08A145.4,145.4,0,0,0,241,333c1.45,2.76,3.05,5.47,4.73,8.13,2.07,3.29,4.23,6.5,6.56,9.59,2.17,3,4.47,5.88,6.9,8.66a148,148,0,0,0,10.52,11q4.9,4.67,10.24,8.87"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M277.87,197.84c1.27,0,2.52.53,3.79.48,3.72-.12,5.88-5.66,3.25-8.35a9.57,9.57,0,0,1-1.65-1.72,3.19,3.19,0,0,1,1.18-3.77,8.6,8.6,0,0,1,3.95-1.29c3.18-.53,6.36-1,9.53-1.54,3.51-.55,8-2.39,7.51-6-.42-3.09-4.54-4.48-5.15-7.55a10.5,10.5,0,0,0-.4-2.25c-1-2-3.86-1.18-5.72-.12a4.57,4.57,0,0,0-7-2.28c-1.88,1.58-2.12,4.36-2.78,6.74-1.55,5.75-6.05,10.12-10.33,14.17-1.44,1.34-3.06,2.78-5,2.87s-4-2-3.11-3.78c.61-1.2,2.31-1.9,2.14-3.24-.23-1.68-3.11-1.56-3.67-3.17,1.13-4.74,6.47-6.71,10.57-9.25a26,26,0,0,0,10.8-13.52,3.49,3.49,0,0,0,.14-2.79c-.61-1.19-2.19-1.39-3.53-1.39-3.15,0-7.08.39-8.24,3.38-.61,1.61-.16,3.43-.54,5.11-1.1,5-7.81,5.54-11.91,8.51-1.6,1.15-2.84,2.76-4.61,3.65s-4.14.86-6.26,1c-.38,0-.75.07-1.13.12q-1.94,2.75-3.75,5.6t-3.48,5.79a151.05,151.05,0,0,0-12.89,29.3c-1.16,3.58-2.17,7.23-3.06,10.93s-1.63,7.45-2.24,11.25c1.46-3.07,2.12-6.86,2.69-9.54.77-3.63,1.92-7.41,4.68-9.84s7.58-2.71,9.72.32c1.53,2.15,1.18,5.1.78,7.74-.55,3.55-1.09,7.1-1.65,10.65a5.58,5.58,0,0,0,.14,3.19c1,2.25,4.66,1.82,6.05-.2s1.24-4.77.87-7.21-.87-5.06.07-7.36c2.35-5.71,10.71-4.85,15.56-8.56,3-2.31,4.35-6.17,6.14-9.55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M519.65,257.45c0-2.18-.08-4.35-.19-6.5s-.28-4.29-.5-6.43c-.16-1.72-.35-3.42-.58-5.13s-.49-3.59-.79-5.36a149.93,149.93,0,0,0-3.47-15.74c-.56-2-1.14-3.94-1.77-5.88s-1.29-3.88-2-5.79v0h0c-.75-1.44-1.55-2.85-2.42-4.24-8.26-13.33-20.27-23.79-29.35-36.54-3-4.15-5.27-7.58-10.52-8.4-7.77-1.22-11.7,3.29-17.21-4.22-1.48-2-4.07-3.88-6.26-2.68.57,1.6,1.16,3.21,1.72,4.84a2.29,2.29,0,0,1,.19,1.06c-.12,1.12-1.76,1.43-2.71.81a9.8,9.8,0,0,1-2.07-2.71,7.52,7.52,0,0,0-11.18-.93,4.33,4.33,0,0,0-2.47-3.55,5.09,5.09,0,0,1-6.4,4.19c-.45-1.46,2.12-1.72,3-3s-.16-2.8-1.22-3.79a16.22,16.22,0,0,0-10.24-4.05c-2.38,0-4.94.41-7-.84-1.2-.72-2-1.92-3.27-2.61-2.62-1.51-5.89-.12-8.52,1.36-3.6,2-7.32,4.61-8.59,8.61s1.55,9.38,5.65,8.87c1-.14,2.11-.64,3.13-.36,1.45.41,2.11,2.14,2.23,3.67s0,3.14.68,4.49,2.85,2,3.68.74c1.93-1.87,1.69-5,1.2-7.67s-1-5.66.54-7.84,6.05-1.49,5.74,1.2c-.19,1.58-1.95,2.73-1.88,4.34s2,2.49,3.62,2.42,3.23-.65,4.78-.24,2.82,2.47,1.69,3.64c-1.95,2.26-7-1.6-8.05,1.2a8.39,8.39,0,0,0-.07,2.3c-.18,2.35-3.08,3.22-5.39,3.5s-4.75.51-6.84-.5-3.53-3.81-2.33-5.83c-1.18-.86-3,0-3.61,1.35a7.84,7.84,0,0,0-.25,4.36c-2.45-.55-4.64,1.56-6,3.64s-2.75,4.56-5.13,5.3-5.7-.26-6.94,2c-1.63,2.87,3.08,6.52,1.43,9.37-.94,1.61-3.2,1.56-5,2.06-4.73,1.37-6.37,8.42-3.15,12.18s9.67,3.55,13.09,0c2.37-2.47,3.34-5.95,5.06-8.92s5-5.64,8.21-4.68a9.72,9.72,0,0,1,3.36,2.16c1.58,1.34,3.16,2.68,4.73,4,1,.86,2.12,1.94,2,3.29-.1,1.07-.92,1.91-1.27,2.92-1,2.9,3.13,5.66,5.72,4.08s2.87-5.64,1.1-8.13c-2.44-3.45-8-5.18-7.83-9.45,2.82-2.35,7.27.12,8.92,3.45s1.69,7.25,3.08,10.67,5.27,6.5,8.52,4.82c-.85-3-1.67-5.92-2.52-8.87,2.07-1.58,4.45,3,6.92,2.26,1.51-.48,1.69-2.69,1-4.18s-1.82-2.73-2.1-4.34c-.47-2.92,2.73-5.54,5.63-5.06s5,3.29,5.5,6.19a13.65,13.65,0,0,0,.76,3.43c1.08,2.3,3.88,3,6.19,4s4.73,3.33,3.76,5.68c-.45,1-1.5,2-1.13,3.07s1.72,1.34,1.72,2.35c0,.67-.71,1.12-1.32,1.39-1.55.65-3.25.86-4.75,1.6s-2.87,2.21-2.76,3.89c.19,2.4,3,3.55,4.31,5.54s1.08,4.41,1.88,6.57c.76,2,2.31,3.55,3.56,5.25,3.9,5.42,4.82,12.39,6.73,18.82.85,2.9,2.4,6.14,5.32,6.69a8.74,8.74,0,0,0,4.7-.93c4.22-1.71,8.59-3.53,11.54-7s3.95-9.18.91-12.61a2.38,2.38,0,0,0-1.43-.93,4.18,4.18,0,0,0-2.21.79c-2.15,1-4.78.17-6.57-1.44a19,19,0,0,1-3.91-6c-1.15-2.37-2.3-4.77-3.48-7.17,1.39-1.2,3.6-.7,5,.48s2.28,2.88,3.43,4.32c3.51,4.46,9.28,6.42,14.85,7.09a13.87,13.87,0,0,1,4.19.89c4.17,1.94,5.37,8.2,9.77,9.54,1.22.39,2.59.31,3.74.87,1.74.83,2.61,2.85,3.13,4.74,1,3.53,1.3,7.24,2.76,10.6s4.37,6.4,7.95,6.45a8.48,8.48,0,0,0,6-2.71v0c.19-3.31.3-6.62.3-10C519.69,258.84,519.69,258.14,519.65,257.45Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M248,329.93a8.58,8.58,0,0,1-1-1.61c-.59-1.09-1.55-2.66-2.56-4.79A134.45,134.45,0,0,1,236.89,305a144.59,144.59,0,0,1,17.9-126.5,134.68,134.68,0,0,1,12.39-15.69c1.56-1.77,2.92-3,3.79-3.9a8.44,8.44,0,0,1,1.42-1.26,8.57,8.57,0,0,1-1.18,1.49c-.79,1-2.06,2.27-3.55,4.09a158.21,158.21,0,0,0-11.89,15.92A147.78,147.78,0,0,0,238,304.66a156.81,156.81,0,0,0,7,18.59c.92,2.17,1.79,3.78,2.28,4.92A8.54,8.54,0,0,1,248,329.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.5,386.51c-.1.19-2.56-.84-6.36-2.83a154.23,154.23,0,0,1-27.69-18.91c-3.24-2.82-5.09-4.73-4.95-4.9.32-.37,8.45,6.42,19.21,13.74S314.73,386.08,314.5,386.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501,218.19c-.34.08-1.47-6.23-5-15.88a123.08,123.08,0,0,0-7.46-16.38A123.42,123.42,0,0,0,461,151.79,123.92,123.92,0,0,0,446.6,141c-8.67-5.5-14.6-7.94-14.46-8.26a24.29,24.29,0,0,1,4.2,1.61,46.24,46.24,0,0,1,4.76,2.27c1.82,1,3.94,2,6.12,3.39A111.4,111.4,0,0,1,462,150.63a117.44,117.44,0,0,1,27.88,34.58,112.68,112.68,0,0,1,7.21,16.71c.92,2.43,1.45,4.72,2,6.7a48.74,48.74,0,0,1,1.2,5.13A24.14,24.14,0,0,1,501,218.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M335.49,147.69c-2.95,1.8-4.52,5.18-6.79,7.8s-6.35,4.49-9,2.31a6.4,6.4,0,0,1-2-4.46,11.63,11.63,0,0,1,1.6-6.94c1.28-2.12,3.24-3.8,4.32-6s.86-5.52-1.36-6.57c-1.2-.57-2.71-.34-3.78-1.14-1.92-1.44-.54-4.84,1.68-5.7s4.7-.2,7.08,0c8.62.56,15-5.19,21.44-10,5-3.71,15.78-8.1,21.61-4.31,2.33,1.52,3.24,5.41,1,7.12-1,.77-2.33.94-3.24,1.79-1.1,1-1.25,2.68-1.88,4-1.63,3.56-6.34,4.85-7.85,8.45-.92,2.18-.5,4.88-1.91,6.76-1.12,1.49-3,2-4.84,2.45L340.32,146A16.65,16.65,0,0,0,335.49,147.69Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M436,334.19c-3.73,5.73-4.41,12.88-5.45,19.67s-2.81,14-7.93,18.48-14.53,4.21-17.34-2c-1.54-3.39-.75-7.38-1.58-11-1.09-4.74-4.79-8.39-6.54-12.9-1.5-3.86-1.5-8.12-1.62-12.26-.67-22.64-6.09-46.27-21.22-62.87-1.86-2-4-4-6.61-4.74a8.34,8.34,0,0,0-8.68,3.05c-1.22,1.64-1.85,3.73-3.33,5.11-3.24,3-8.88.86-11-3s-1.86-8.64-1.5-13.09q.68-8.26,1.34-16.53c.24-2.89.56-6,2.41-8.17,2.64-3.11,7.38-3.26,10.61-5.72,4.24-3.24,4.8-9.41,7.48-14.06s11-6.63,12.27-1.38c8.84-19.29,28.39,9.36,40,7.21,3.38-.63,6.67-2.28,10.07-1.79,6,.85,9.1,7.59,11.14,13.4l10.17,28.94c1.29,3.67,3,7.75,6.53,9.16,2.73,1.09,5.91.26,8.67,1.28,7.3,2.71,4.93,14.4-.94,19.58S448.8,298.92,446,306.3c-2.1,5.56-.43,12.08-2.69,17.57C441.7,327.8,438.3,330.64,436,334.19Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M463.67,340.48c-2.39.34-5.22-.86-7,.76-1.07.95-1.3,2.5-1.72,3.87a8.27,8.27,0,0,1-3.4,4.73,5,5,0,0,1-5.54-.1,3.87,3.87,0,0,1-.77-5.29c.59-.69,1.43-1.1,2.07-1.73,3.18-3.06,1-8.74,3.43-12.38,1.42-2.15,3.67-4.33,5.23-6.5,1.21-1.67,1.65-3,3.87-3.45C469.49,318.45,473.87,339,463.67,340.48Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M468.07,184.73c.48-3.46-4.4-6.31-8.07-6.6-1.75-.14-3.57.13-5.22-.45-3.59-1.25-5-5.89-8.53-7.37-2.62-1.1-5.63-.12-8.17,1.16s-5.05,2.88-7.89,3.07c-2.46.15-5.14-.76-7.3.44-1.61.9-2.45,2.75-3.93,3.85a9.42,9.42,0,0,1-5.15,1.39,14.53,14.53,0,0,0-5.3.87c-1.64.75-3,2.48-2.65,4.25Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.64,266.07c.74-5.36-6.83-9.77-12.51-10.23-2.71-.22-5.52.2-8.09-.7-5.56-1.94-7.79-9.12-13.21-11.41-4.06-1.71-8.73-.19-12.67,1.79S295.34,250,291,250.27c-3.82.25-8-1.17-11.32.7-2.49,1.39-3.8,4.26-6.09,6s-5.18,2-8,2.17-5.68.17-8.22,1.34-4.64,3.84-4.11,6.59Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-244"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M693.75,478.33c0,.14-144.51.26-322.73.26s-322.77-.12-322.77-.26,144.48-.26,322.77-.26S693.75,478.18,693.75,478.33Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Birds--inject-244"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356.33,89.53s-.81-.28-2.32-.62a18.49,18.49,0,0,0-6.47-.25,17.47,17.47,0,0,0-8.72,3.76,18.15,18.15,0,0,0-6.16,9.78l0,.11-.18.7-.26-.67a19.49,19.49,0,0,0-7.38-8.9,18.82,18.82,0,0,0-9-3,19.84,19.84,0,0,0-6.43.59c-1.48.39-2.27.74-2.29.69a6,6,0,0,1,.56-.27,13.69,13.69,0,0,1,1.68-.59,19.19,19.19,0,0,1,15.72,2.22,19.72,19.72,0,0,1,7.57,9.09l-.45,0,0-.11a18.42,18.42,0,0,1,6.34-10,17.66,17.66,0,0,1,9-3.76,18,18,0,0,1,6.55.4,13.72,13.72,0,0,1,1.71.54A2.88,2.88,0,0,1,356.33,89.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.42,52.43s-.46-.13-1.28-.3a10.39,10.39,0,0,0-3.55-.11,9.6,9.6,0,0,0-4.74,2.07,9.9,9.9,0,0,0-3.35,5.33v.06l-.18.7-.27-.67a10.6,10.6,0,0,0-4-4.85,10.29,10.29,0,0,0-4.9-1.66,11.25,11.25,0,0,0-3.52.29c-.82.2-1.26.38-1.27.34a1.2,1.2,0,0,1,.3-.17,7,7,0,0,1,.92-.34,10.48,10.48,0,0,1,8.71,1.18,10.91,10.91,0,0,1,4.21,5l-.45,0,0-.06a10.06,10.06,0,0,1,3.53-5.55,9.78,9.78,0,0,1,8.6-1.81,5.36,5.36,0,0,1,.93.32C412.32,52.36,412.43,52.41,412.42,52.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.47,34.19a18.58,18.58,0,0,1-1.24,1.41,29.54,29.54,0,0,0-3,4.1,29.93,29.93,0,0,0-4.51,16v.2l-.47,0a26.22,26.22,0,0,0-2.92-8.64,26.63,26.63,0,0,0-4.44-6A27.53,27.53,0,0,0,344,38a16.14,16.14,0,0,1-1.53-1.06,2.73,2.73,0,0,1,.43.21c.27.16.7.36,1.2.7a23.84,23.84,0,0,1,4,3.18,26.41,26.41,0,0,1,4.59,6,26,26,0,0,1,3,8.78l-.46,0v-.2a29.42,29.42,0,0,1,4.7-16.15,27,27,0,0,1,3.18-4c.41-.45.77-.76,1-1A2.45,2.45,0,0,1,364.47,34.19Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-244"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M646.83,271.21l17-8.84s14.7,14.31,18,13l-16-33.6-27.07,12.69Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.45,252.67a1.51,1.51,0,0,1,1.11-1.69,1.46,1.46,0,0,1,1.69,1.09,1.6,1.6,0,0,1-1.19,1.78c-.74.08-1.67-.58-1.63-1.32",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M665.88,241.76l-2.68,1.39,16.31,31.69s1.36,1.19,2.33.52Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M663.93,263c.16-.08-.16-.94,0-2s.63-1.82.49-1.94-1,.57-1.12,1.86S663.79,263.1,663.93,263Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.06,265.82c.17,0,.12-.88.55-1.76s1.08-1.4,1-1.56-1.07.18-1.58,1.29S666.9,265.89,667.06,265.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.23,265.82c0-.16-1,0-1.67.84s-.69,1.79-.52,1.79.43-.69,1-1.38S672.29,266,672.23,265.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.83,264.58c.11-.14-.47-.79-.85-1.74s-.43-1.82-.61-1.84-.43.95,0,2.07S659.74,264.72,659.83,264.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "602.07 265.35 648.99 247.83 658.3 266.81 609.61 292.43 602.07 265.35",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489,60.86s-7.61,3.29-7,9.2a57.31,57.31,0,0,0,2.48,11.29s-12-9.09-23.66-5.42l-.07,2.71s8.39-1,15.58,3S493,99.82,493,99.82l23.62-10.61L511,80.1s.78-8.63.91-11C512.15,65.36,507.62,51.13,489,60.86Zm19.88,6c.24,2.1-1.53,5.26-1.53,5.26l-2.49-5.79-18.75,6.47s-3.38-5.59,3.48-9.25c4-2.15,8.43-2.36,11.31-2.5a7.93,7.93,0,0,1,6.93,3.23A5.7,5.7,0,0,1,508.92,66.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489,60.86s-7.61,3.29-7,9.2a57.31,57.31,0,0,0,2.48,11.29s-12-9.09-23.66-5.42l-.07,2.71s8.39-1,15.58,3S493,99.82,493,99.82l23.62-10.61L511,80.1s.78-8.63.91-11C512.15,65.36,507.62,51.13,489,60.86Zm19.88,6c.24,2.1-1.53,5.26-1.53,5.26l-2.49-5.79-18.75,6.47s-3.38-5.59,3.48-9.25c4-2.15,8.43-2.36,11.31-2.5a7.93,7.93,0,0,1,6.93,3.23A5.7,5.7,0,0,1,508.92,66.85Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.92,66.85a6.57,6.57,0,0,0-1-2.32,7.27,7.27,0,0,0-2.11-2.05,8.14,8.14,0,0,0-3.67-1.23,14.85,14.85,0,0,0-2.29,0c-.8.05-1.63.11-2.49.22A24.08,24.08,0,0,0,492,62.74a12.55,12.55,0,0,0-5,3.15,5.81,5.81,0,0,0-1.32,2.77,6.31,6.31,0,0,0,.33,3.15,6.05,6.05,0,0,0,.38.85l-.3-.11,18.77-6.42.18-.06.07.17c.93,2.24,1.75,4.18,2.43,5.81h-.26a14.53,14.53,0,0,0,1.5-3.75,8.06,8.06,0,0,0,.16-1.44,3.36,3.36,0,0,1,0,1.46,13.26,13.26,0,0,1-1.4,3.87l-.13.27-.13-.28-2.53-5.77.25.11L486.24,73l-.21.07-.1-.18a7.19,7.19,0,0,1-.43-.94,6.75,6.75,0,0,1-.35-3.41,6.35,6.35,0,0,1,1.44-3,13.07,13.07,0,0,1,5.26-3.27,24.22,24.22,0,0,1,5.46-1.2c.87-.1,1.71-.15,2.52-.19a14.2,14.2,0,0,1,2.35,0A8.26,8.26,0,0,1,506,62.24a7.2,7.2,0,0,1,2.12,2.18,5.73,5.73,0,0,1,.76,1.76A2.12,2.12,0,0,1,508.92,66.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489,60.86l.67-.35,2-1,.69-.33.8-.28,1.83-.65c.66-.24,1.42-.34,2.2-.54a13.37,13.37,0,0,1,2.54-.31l.69,0c.23,0,.47,0,.71,0l1.46.12a12.52,12.52,0,0,1,3,1,11.58,11.58,0,0,1,5,4.91A15.13,15.13,0,0,1,512,67.14c.07.33.1.67.16,1a9.2,9.2,0,0,1,0,1c0,.68-.11,1.38-.17,2.08q-.33,4.22-.71,8.84l0-.13,5.6,9.1.14.23-.25.11-23.62,10.62-.2.09-.12-.18c-1.31-2-2.79-4-4.33-6a84.25,84.25,0,0,0-5.68-6.7,30.07,30.07,0,0,0-6.47-5.42,24.89,24.89,0,0,0-7.69-2.6,31.42,31.42,0,0,0-7.77-.36l-.27,0v-.27c0-.92.05-1.82.08-2.71v-.17l.16,0a21.82,21.82,0,0,1,6.93-.83A26.31,26.31,0,0,1,474.18,76a33.77,33.77,0,0,1,5.66,2.28,36.32,36.32,0,0,1,4.81,2.91l-.28.2a57.84,57.84,0,0,1-2.26-9.75,9.4,9.4,0,0,1,.06-4.1,8.26,8.26,0,0,1,1.7-3,14.48,14.48,0,0,1,3.69-3c.47-.28.84-.45,1.09-.57a2,2,0,0,1,.39-.16,2.56,2.56,0,0,1-.36.2c-.24.14-.61.33-1.07.61a15.14,15.14,0,0,0-3.59,3,8,8,0,0,0-1.61,2.95,8.93,8.93,0,0,0,0,4,58.22,58.22,0,0,0,2.31,9.68l.17.53-.45-.33a34.33,34.33,0,0,0-4.77-2.84,32.53,32.53,0,0,0-5.6-2.23,25.65,25.65,0,0,0-6.34-1.11,21.39,21.39,0,0,0-6.77.83l.17-.21c0,.88-.05,1.78-.07,2.7l-.27-.24a31.54,31.54,0,0,1,7.91.34,25.63,25.63,0,0,1,7.85,2.64,31.14,31.14,0,0,1,6.6,5.51,87.06,87.06,0,0,1,5.71,6.74c1.55,2,3,4.07,4.35,6l-.32-.09L516.52,89l-.11.34-5.57-9.12,0-.06v-.08c.26-3.07.51-6,.75-8.83.06-.7.12-1.39.17-2.07a8.16,8.16,0,0,0,0-1c-.05-.33-.09-.66-.15-1a14.57,14.57,0,0,0-1.28-3.59,11.26,11.26,0,0,0-4.82-4.8,12.63,12.63,0,0,0-2.91-1l-1.43-.13c-.23,0-.46-.05-.69-.06l-.68.05a13.11,13.11,0,0,0-2.51.28c-.77.18-1.52.27-2.18.5l-1.83.61-.8.27-.7.31-2,.9C489.29,60.77,489,60.86,489,60.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.83,57l-10.23-.46-8.39,3.64s.39,1.31,1.18,1.22a33.12,33.12,0,0,0,4.72-1.33l-2.68,2.34-.11,1.72s2.64,3.22,3.1,2.87a4.6,4.6,0,0,0,.92-1.49l1.84,2.64h2.87l1.32-1.77,1.39,1.13s3.58,3.25,5.64,2.5c1.19-.43,3.38,4.93,3.38,4.93l7.76-4.93-5.19-6.43Z",
    style: {
      fill: "#b28572"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.24,60.25a5.78,5.78,0,0,1-1.78.25l-1.92.11a3.24,3.24,0,0,0-1,.18,7.21,7.21,0,0,0-1,.59c-.7.46-1.34.93-1.9,1.37s-1.05.82-.88,1.31c.29,1,.75,1.55.67,1.6s-.62-.4-1-1.5a1.11,1.11,0,0,1,.15-1,4.31,4.31,0,0,1,.78-.76,19.4,19.4,0,0,1,1.91-1.44,7.59,7.59,0,0,1,1.12-.64,3.72,3.72,0,0,1,1.19-.17h1.95A6.25,6.25,0,0,1,508.24,60.25Z",
    style: {
      fill: "#7f5c4f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.05,68.28c-.08,0,.19-.54.63-1.3.11-.19.22-.41.33-.63a1.22,1.22,0,0,0,.1-.31s0,0,0,0,0,0,0-.07l-.09-.12a1.25,1.25,0,0,0-1.47,0l-.42.22-.33.16-.08-.37q-.1-.52-.21-1c-.08-.31-.23-.54-.39-.58l-.7-.15.64-.29c.65-.29,1.18-.52,1.57-.66a2.73,2.73,0,0,1,.47-.15c.13,0,.2.05.18.07a2.78,2.78,0,0,0-.53.32c-.35.22-.86.51-1.48.84l-.05-.44a1.2,1.2,0,0,1,.79.88c.09.37.17.73.26,1.11l-.4-.21.45-.23a2.29,2.29,0,0,1,1.08-.25,1.42,1.42,0,0,1,1,.46,1,1,0,0,1,.15.24.5.5,0,0,1,.05.13.51.51,0,0,1,0,.21,1.36,1.36,0,0,1-.18.45,6.92,6.92,0,0,1-.4.63C505.48,67.91,505.11,68.31,505.05,68.28Z",
    style: {
      fill: "#7f5c4f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.79,58.07a32,32,0,0,1-5.62.27l.19-.08a6.44,6.44,0,0,1-.56.48c-1.37,1.1-2.65,2-3.58,2.69a8,8,0,0,1-1.58,1c-.12-.14,2.09-2,4.82-4.11.18-.15.37-.3.52-.44l.09-.08h.1A30.27,30.27,0,0,1,507.79,58.07Z",
    style: {
      fill: "#7f5c4f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.06,352.33l7.63,17.59S597.38,383.58,598.47,387L633.1,373.4l-10.77-27.89Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.81,364.22a1.52,1.52,0,0,1,1.61,1.23,1.46,1.46,0,0,1-1.21,1.61,1.61,1.61,0,0,1-1.7-1.31c0-.75.7-1.62,1.44-1.54",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M633.1,373.4l-1.2-2.77-32.75,14s-1.28,1.28-.68,2.3Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M612.06,370c.07.17.94-.09,2,.13s1.77.76,1.9.63-.51-1-1.78-1.25S612,369.82,612.06,370Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609,372.89c0,.18.87.18,1.73.67s1.32,1.18,1.48,1.1-.1-1.07-1.17-1.66S609,372.72,609,372.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.65,378c.17,0,.08-1-.72-1.71s-1.73-.82-1.75-.65.67.47,1.31,1.1S608.48,378.09,608.65,378Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.76,365.76c.13.13.82-.41,1.8-.72s1.84-.3,1.88-.48-.93-.5-2.08-.12S610.63,365.66,610.76,365.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.7,189.76s7.44,105.64,10.38,108.81,29.52,65.85,29.52,65.85,19.4-8.32,19.56-8.76-16.22-65.16-18.45-73.28c0,0,5.76-51.65,7.48-57.44s7.1-19,4.78-28.18a59.11,59.11,0,0,0-6.88-16.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.48,300.83s-.21-.62-.5-1.76-.67-2.79-1.09-4.85-.89-4.51-1.37-7.25-1-5.73-1.28-8.94a70.24,70.24,0,0,1,.75-9c.37-2.73.71-5.2,1-7.31s.5-3.68.67-4.92l.18-1.34a4.57,4.57,0,0,1,.08-.47s0,.17,0,.47-.08.82-.14,1.35c-.15,1.25-.36,2.91-.6,4.93s-.59,4.58-1,7.31a72.39,72.39,0,0,0-.73,9c.28,3.17.82,6.19,1.26,8.92s.92,5.19,1.32,7.25.77,3.72,1,4.86c.13.52.23,1,.32,1.32S614.48,300.83,614.48,300.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "544.8 232.3 523.56 478.33 536.01 478.11 555.88 232.18 544.8 232.3",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "561.52 232.12 550 232.68 619.58 478.05 631.87 478.05 561.52 232.12",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "543.89 345.51 584.12 345.51 587.48 355.09 541.15 355.09 543.89 345.51",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536,478.11c-.14,0,4-51.07,9.15-114s9.52-114,9.67-114-4,51.07-9.15,114.05S536.16,478.12,536,478.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.58,478.05c-.14,0-15.61-53.89-34.54-120.44S550.86,237.05,551,237s15.6,53.88,34.54,120.46S619.72,478,619.58,478.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.39,84.93a12.56,12.56,0,0,1,10.2-6l-.4,1.12a7.32,7.32,0,0,1,7.26,12.7c2.12,2,2,5.71.08,7.93a9.1,9.1,0,0,1-7.93,2.77,12.29,12.29,0,0,1-9.21-18.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.76,76.2c-.61-1.66-.34-3.5-.56-5.25a11.15,11.15,0,0,0-7.14-8.53,17.05,17.05,0,0,0-11.43.06,15.94,15.94,0,0,0-7.25,4.59A12.11,12.11,0,0,0,561,77.9l19.73-2.62a22.18,22.18,0,0,0,5.92,4,4.07,4.07,0,0,0,2.05.35,1.82,1.82,0,0,0,1.55-1.24A3.82,3.82,0,0,0,589.76,76.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.29,71.78l-17.15-3.87c-5.47-.43-8.93,6.38-9.13,11.87-.22,6.09-.26,13.54.58,18.06,1.69,9.09,8.71,10.07,8.71,10.07s.21,11,.34,14.29c6.2,3,12.41-2.24,18.92-5.15L590.24,75A3.2,3.2,0,0,0,587.29,71.78Z",
    style: {
      fill: "#b28572"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.4,86.62a1.17,1.17,0,0,0,1.16,1.15,1.11,1.11,0,0,0,1.18-1.08,1.16,1.16,0,0,0-1.16-1.15A1.12,1.12,0,0,0,563.4,86.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.73,83.6c.14.15,1-.53,2.27-.56s2.2.58,2.34.42-.09-.34-.5-.62a3.2,3.2,0,0,0-1.87-.52,3.08,3.08,0,0,0-1.81.63C562.78,83.26,562.65,83.54,562.73,83.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.2,86.56a1.17,1.17,0,0,0,1.16,1.15,1.11,1.11,0,0,0,1.18-1.08,1.17,1.17,0,0,0-1.16-1.16A1.13,1.13,0,0,0,575.2,86.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.11,83.52c.15.15,1-.53,2.28-.56s2.2.57,2.33.42-.08-.35-.5-.63a3.23,3.23,0,0,0-3.68.11C575.17,83.17,575,83.45,575.11,83.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.79,93a8.51,8.51,0,0,0-2.06-.32c-.32,0-.63-.08-.69-.3a1.71,1.71,0,0,1,.19-1l.89-2.47a42.36,42.36,0,0,0,2-6.46,42.2,42.2,0,0,0-2.49,6.29l-.84,2.48a1.86,1.86,0,0,0-.14,1.27.84.84,0,0,0,.54.46,2.3,2.3,0,0,0,.55.06A8.17,8.17,0,0,0,570.79,93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.3,107.91a23.3,23.3,0,0,0,12.14-3.58s-2.91,6.4-12.06,5.78Z",
    style: {
      fill: "#7f5c4f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.4,96a2.27,2.27,0,0,1,2-.9,2.11,2.11,0,0,1,1.45.73,1.32,1.32,0,0,1,.14,1.5,1.51,1.51,0,0,1-1.64.46,4.74,4.74,0,0,1-1.64-.91,1.41,1.41,0,0,1-.36-.37.43.43,0,0,1,0-.47",
    style: {
      fill: "#7f5c4f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.52,93.75c-.21,0-.18,1.36-1.32,2.37s-2.61.88-2.61,1.07.33.26.94.26a3.39,3.39,0,0,0,2.19-.82,3,3,0,0,0,1-2C574.77,94.08,574.61,93.74,574.52,93.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.8,79.71c.14.34,1.39.15,2.87.29s2.69.51,2.88.2c.08-.15-.13-.47-.62-.79a5,5,0,0,0-4.38-.37C575,79.28,574.75,79.55,574.8,79.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563,78.09c.23.28,1.09,0,2.13-.08s1.93.14,2.13-.17c.08-.14-.06-.43-.46-.69a2.93,2.93,0,0,0-1.74-.42,3,3,0,0,0-1.69.62C563,77.65,562.85,78,563,78.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578,61.51l-8.78,5.35a8.49,8.49,0,0,0,5.82,6.46c1.56.47,3.44.58,4.37,1.92s.42,3.36,1.31,4.76c1.23,2,4.57,1.83,5.5,3.94.41.92.21,2,.63,2.94.56,1.22,3.67,2.75,4.94,2.33s2.81.64,3.22-.5c0,0,3.22-3.06,2.28-9.27s-1.75-8.8-6-13S582.66,59.66,578,61.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.06,90.32c0-.68.72-2.31,1.39-2.43,1.79-.32,5-.26,5.17,4.29.2,6.22-6.08,5.14-6.1,5S588.11,92.66,588.06,90.32Z",
    style: {
      fill: "#b28572"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.34,94.72s.11.07.3.15a1.07,1.07,0,0,0,.81,0,2.66,2.66,0,0,0,1.16-2.44,3.64,3.64,0,0,0-.35-1.55,1.26,1.26,0,0,0-.84-.8.54.54,0,0,0-.63.32c-.08.17,0,.3-.07.31s-.14-.1-.1-.36a.72.72,0,0,1,.24-.4.87.87,0,0,1,.59-.18,1.52,1.52,0,0,1,1.16.93,3.72,3.72,0,0,1,.44,1.72,2.82,2.82,0,0,1-1.5,2.74,1.14,1.14,0,0,1-1-.13C590.36,94.87,590.32,94.73,590.34,94.72Z",
    style: {
      fill: "#7f5c4f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.66,97.65s.08-.05.22-.16a2.3,2.3,0,0,0,.45-.64,2.65,2.65,0,0,0,.25-1.21,2.55,2.55,0,0,0-.52-1.55c-.38-.52-1-.77-1.52-1.24a.88.88,0,0,1-.27-.9,1.34,1.34,0,0,1,.77-.7,7.54,7.54,0,0,1,1.16-.31,1.89,1.89,0,0,0,1.14-.66,1.66,1.66,0,0,0,.21-1.35,3.63,3.63,0,0,0-.56-1.27,9.13,9.13,0,0,1-.67-1.16,2,2,0,0,1-.17-1.22,8,8,0,0,1,1.11-2.18,12.79,12.79,0,0,0,1.44-4,12.26,12.26,0,0,0,.18-2.84,7.66,7.66,0,0,0-.07-.77.84.84,0,0,0,0-.27s0,.37,0,1a13.68,13.68,0,0,1-.26,2.82,12.84,12.84,0,0,1-1.46,3.9,8.13,8.13,0,0,0-1.14,2.24,2.25,2.25,0,0,0,.18,1.35,9.36,9.36,0,0,0,.68,1.19,3.54,3.54,0,0,1,.54,1.19,1.49,1.49,0,0,1-.17,1.18,1.71,1.71,0,0,1-1,.59,7.22,7.22,0,0,0-1.19.32,1.46,1.46,0,0,0-.87.83,1,1,0,0,0,0,.61,1.35,1.35,0,0,0,.32.48c.53.51,1.18.73,1.53,1.2a2.67,2.67,0,0,1,.31,2.63A2.7,2.7,0,0,1,557.66,97.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.22,93.07a6.33,6.33,0,0,0,.86-1.39,8,8,0,0,0-2.61-9.91A21.74,21.74,0,0,0,590,80a6,6,0,0,1-1.65-1.13,5.17,5.17,0,0,1-1.07-1.76c-.5-1.32-.69-2.73-1.3-4a4.25,4.25,0,0,0-1.28-1.56,5,5,0,0,0-1.76-.78c-1.21-.31-2.4-.37-3.45-.65A9.22,9.22,0,0,1,576.71,69a9.72,9.72,0,0,1-3.61-4.18l-.13-.29-.05-.09a6.89,6.89,0,0,0,.67,1.48,9.51,9.51,0,0,0,3,3.21,9.24,9.24,0,0,0,2.8,1.26c1.08.29,2.26.35,3.45.67a4.92,4.92,0,0,1,1.69.75,4,4,0,0,1,1.2,1.48c.6,1.19.79,2.6,1.3,4a5.45,5.45,0,0,0,1.11,1.83,6.2,6.2,0,0,0,1.72,1.18,21.74,21.74,0,0,1,3.45,1.71,8,8,0,0,1,3.27,5.41,8.25,8.25,0,0,1-.62,4.3,9.33,9.33,0,0,1-.56,1.06l-.17.26A.26.26,0,0,0,595.22,93.07Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.38,90.25a6,6,0,0,0,.64-1.32,9.05,9.05,0,0,0,.5-4,8.62,8.62,0,0,0-2.52-5.3,8,8,0,0,0-1.37-1.05c-.5-.32-1-.6-1.52-.93a5.71,5.71,0,0,1-1.37-1.18,4.68,4.68,0,0,1-.79-1.67c-.17-.61-.3-1.24-.51-1.84a5.1,5.1,0,0,0-1-1.62,7,7,0,0,0-3-1.89,20.52,20.52,0,0,0-3.08-.75,17.79,17.79,0,0,1-2.66-.67,6.62,6.62,0,0,1-3.19-2.24,6.74,6.74,0,0,1-.68-1.28.32.32,0,0,0,0,.09l.09.27a4.73,4.73,0,0,0,.5,1,6.69,6.69,0,0,0,3.2,2.34,17.12,17.12,0,0,0,2.68.7,22.39,22.39,0,0,1,3.06.76,6.93,6.93,0,0,1,2.86,1.85,4.71,4.71,0,0,1,.92,1.54c.21.58.33,1.2.51,1.83a4.79,4.79,0,0,0,.83,1.75A5.86,5.86,0,0,0,592,77.88a16.21,16.21,0,0,1,2.87,2A8.52,8.52,0,0,1,597.37,85a9.16,9.16,0,0,1-.43,3.92c-.15.44-.3.77-.4,1A2.38,2.38,0,0,0,596.38,90.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.71,67.32s.32-.31.89-.74a7.08,7.08,0,0,1,2.45-1.19,7,7,0,0,1,2.73-.18c.7.09,1.12.24,1.13.2s-.09-.06-.28-.13a3.84,3.84,0,0,0-.83-.22,5.85,5.85,0,0,0-1.26-.11,7.23,7.23,0,0,0-1.54.22,6.85,6.85,0,0,0-1.45.58,6.36,6.36,0,0,0-1,.71,4.92,4.92,0,0,0-.61.61C563.77,67.22,563.7,67.31,563.71,67.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.56,99.62a.46.46,0,0,0,.23.1.88.88,0,0,0,.68-.23.82.82,0,0,0,.27-.45,1,1,0,0,0-.06-.63,1.42,1.42,0,0,0-1.23-.82,2.63,2.63,0,0,0-1.72.58,2.15,2.15,0,0,0-.65.8,1.76,1.76,0,0,0-.13,1.09,2.31,2.31,0,0,0,1.52,1.7,3.55,3.55,0,0,0,2.46-.15,5.21,5.21,0,0,0,3-3.54A4.89,4.89,0,0,0,599,96a5.18,5.18,0,0,0-.67-1.68,5.09,5.09,0,0,0-1.88-1.8,3,3,0,0,0-.36-.18l-.28-.11-.24-.06s.32.11.84.42a5.18,5.18,0,0,1,1.78,1.81,4.71,4.71,0,0,1,.55,3.63,5.06,5.06,0,0,1-2.89,3.39,3.37,3.37,0,0,1-2.31.14,2.1,2.1,0,0,1-1.39-1.53,1.76,1.76,0,0,1,.69-1.71,2.43,2.43,0,0,1,1.6-.56,1.27,1.27,0,0,1,1.13.71.93.93,0,0,1,.07.56.79.79,0,0,1-.23.41.84.84,0,0,1-.61.24A1.43,1.43,0,0,1,594.56,99.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.9,110.59a5.09,5.09,0,0,1-.66.34,2.75,2.75,0,0,1-2,0,2.64,2.64,0,0,1-1.66-2.25,2.6,2.6,0,0,1,.45-1.63,2.4,2.4,0,0,1,1.48-1,1.3,1.3,0,0,1,.87.13,1,1,0,0,1,.44.7.65.65,0,0,1-.35.65,1.05,1.05,0,0,1-.78.07,1.89,1.89,0,0,1-1.15-1,3.14,3.14,0,0,1-.35-1.32,6.25,6.25,0,0,1,.35-2c.14-.46.22-.72.21-.72s0,0-.09.17l-.21.52a6,6,0,0,0-.41,2,3.1,3.1,0,0,0,.34,1.4,2.07,2.07,0,0,0,1.26,1.08,1.37,1.37,0,0,0,.93-.08.85.85,0,0,0,.46-.87,1.19,1.19,0,0,0-.54-.86,1.45,1.45,0,0,0-1-.15,2.54,2.54,0,0,0-1.62,1.12,2.73,2.73,0,0,0-.47,1.77,2.8,2.8,0,0,0,1.8,2.38,2.75,2.75,0,0,0,2-.09,2.41,2.41,0,0,0,.49-.29A1,1,0,0,0,594.9,110.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.84,93.26a4.3,4.3,0,0,1,1.37.5,4.24,4.24,0,0,1,1,1.07.76.76,0,0,0-.13-.44,2.25,2.25,0,0,0-1.78-1.19C574,93.18,573.83,93.23,573.84,93.26Z",
    style: {
      fill: "#7f5c4f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.58,92.45a6.41,6.41,0,0,1,1.45.85,6.29,6.29,0,0,1,1,1.34,1.05,1.05,0,0,0-.12-.5,3.07,3.07,0,0,0-.74-1,2.93,2.93,0,0,0-1.09-.62C574.78,92.42,574.58,92.42,574.58,92.45Z",
    style: {
      fill: "#7f5c4f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.83,75.11a9.52,9.52,0,0,0,2.63.48,9.26,9.26,0,0,0,2.67-.06c0-.06-1.19,0-2.65-.16S568.84,75,568.83,75.11Z",
    style: {
      fill: "#7f5c4f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.49,76.12a9.8,9.8,0,0,0,2.07.15,8.68,8.68,0,0,0,2.08-.07,10.66,10.66,0,0,0-2.07-.15A10.12,10.12,0,0,0,569.49,76.12Z",
    style: {
      fill: "#7f5c4f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.84,86a3.52,3.52,0,0,0,.2-1,12.53,12.53,0,0,0-.43-4.82,3.22,3.22,0,0,0-.37-.93,28.88,28.88,0,0,1,.6,3.34A29,29,0,0,1,597.84,86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.24,91.68a1.87,1.87,0,0,0,.11-1,3.44,3.44,0,0,0-3-3.19,1.91,1.91,0,0,0-.95,0s.36,0,.93.12a3.63,3.63,0,0,1,1.91,1.06,3.67,3.67,0,0,1,.92,2C601.27,91.32,601.2,91.68,601.24,91.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.77,226.33l-11.86,1.31-7.25,4.54s-.14,1.48,1.92,1.24l4.08-1.72-3.23,3.54s.78,1.42,2.56.42a10,10,0,0,0,2.88-2.48l7.13-.5s-5.39,5.18-4.4,6.53,1.63,1.07,2.41.57,1.21-2.2,3-2.77,4.7-2.22,7.88-3.73c2.73-1.29,6.09-10.67,6.09-10.67l-9.79-1.92Z",
    style: {
      fill: "#b28572"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.05,229.36a42.92,42.92,0,0,1-6.75,1.29h-.1l.16-.08a42,42,0,0,1-4.93,4.66,42.79,42.79,0,0,1,4.53-5l.07-.07h.09l.1,0A43,43,0,0,1,549.05,229.36Z",
    style: {
      fill: "#7f5c4f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "570 156.68 551.96 220.08 566.13 222.84 575.48 190.88 570 156.68",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M563.54,179.77h0c-2.55,12.33-1.54,26,3.6,37.48C567.28,205.12,565.37,191.77,563.54,179.77Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M561.26,166.49s0,.15.1.42.15.74.24,1.21c.23,1.13.53,2.62.89,4.43.76,3.74,1.83,8.9,2.9,14.63.53,2.86,1,5.6,1.38,8.09s.6,4.77.86,6.65a9.39,9.39,0,0,0,1.5,4.19,8.79,8.79,0,0,0,1.12,1.21s-.12-.08-.34-.26a5.08,5.08,0,0,1-.84-.9,9.14,9.14,0,0,1-1.59-4.21c-.27-1.9-.48-4.16-.9-6.65s-.86-5.22-1.4-8.08c-1.09-5.68-2.09-10.81-2.83-14.64-.34-1.81-.62-3.31-.83-4.45-.08-.47-.14-.87-.2-1.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.23,188.33c-1.49-4.32-16.78-21.55-16.78-21.55s-1-9.91-1.45-14.24c-.33-2.93-.72-14.88-1.11-24.11-.34-8-11.27-15.12-11.27-15.12H575l5.2,1.37-11.83,8.07s-16,16-13.56,28.47c3.06,15.69,14.7,56.1,14.7,56.1l17.15-4.44c4.38-1.13,7.51-2.65,14.36-3.35L622,195.35A33.42,33.42,0,0,0,620.23,188.33Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.93,124.16,584,115.79l-35-17.43-21.93-31-13.45,8.31,19.81,41.66a11.45,11.45,0,0,0,5,4.79l41.22,18.52h0Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.94,140.3l-.43-.19-1.23-.56c-1-.49-2.6-1.18-4.51-2-3.84-1.67-9.21-3.77-15.17-6s-11.3-4.49-15.07-6.3c-1.89-.9-3.4-1.66-4.43-2.22l-1.18-.65a4.06,4.06,0,0,1-.4-.23s.15.06.42.2l1.2.6c1,.54,2.56,1.28,4.45,2.16,3.79,1.78,9.13,4,15.09,6.24s11.32,4.41,15.14,6.11c1.91.85,3.45,1.56,4.5,2.08l1.21.6A4.23,4.23,0,0,1,580.94,140.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.34,122.09l-.22-.16-.62-.5c-.55-.41-1.37-1-2.41-1.62-2.09-1.29-5.11-2.85-8.49-4.47s-6.49-3-8.73-4l-2.64-1.23-.71-.35c-.16-.09-.25-.13-.24-.14a1.42,1.42,0,0,1,.26.1l.72.31,2.67,1.18c2.25,1,5.36,2.36,8.76,4a87.73,87.73,0,0,1,8.48,4.53c1,.67,1.84,1.26,2.38,1.69l.59.53C595.28,122,595.35,122.08,595.34,122.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M563.14,131.64c5.34,9.06,17.52,14.34,28.05,14.37-7.87-5.08-19.42-10-28.05-14.37"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M606.89,171.21c-.27-1.45-2.77-1.75-4.23-1.93a10.46,10.46,0,0,0-4.34.68l-8.21,2.51c-2.73.84-5.58,1.74-7.61,3.75a11.85,11.85,0,0,0-3.09,8.57,33.14,33.14,0,0,0,1.79,9.14,40.27,40.27,0,0,1,2,9.1l1.45.85c2.35-1.18,3.72-3.75,4.27-6.32a52.68,52.68,0,0,0,.58-7.85c.17-2.62.68-5.35,2.29-7.42,2.53-3.26,7-4.1,10.7-5.89C604.31,175.52,607.25,173.19,606.89,171.21Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M603.45,166.78l-42.19,8.59,12.38,93.08,16.77-3.85s-7.37-78.92-5.54-82.66,11.06-7.2,11.06-7.2l11-4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.9,170s0-.32.06-.93.11-1.55.18-2.68a62.54,62.54,0,0,1,1.1-9.79,19.65,19.65,0,0,1,2.63-6.28,6.06,6.06,0,0,1,2.73-2.61,1.71,1.71,0,0,1,1.89.54,3.31,3.31,0,0,1,.61,2,24.75,24.75,0,0,1-6.27,16.43,26.05,26.05,0,0,1-2.18,2.16l-.14-.16a74.94,74.94,0,0,1,13.84-9.57,4.09,4.09,0,0,1,1.86-.51,1.79,1.79,0,0,1,1.59,1,2.56,2.56,0,0,1,.16,1.82,3.61,3.61,0,0,1-.92,1.5,15.89,15.89,0,0,1-2.64,2c-.89.58-1.77,1.09-2.63,1.54a33.55,33.55,0,0,1-8.58,3.1,26.93,26.93,0,0,1-3.29.52l.85-.14c.56-.08,1.38-.22,2.42-.45a34.44,34.44,0,0,0,8.53-3.16c.85-.45,1.73-1,2.61-1.54a16,16,0,0,0,2.61-2,3.45,3.45,0,0,0,.87-1.44,2.36,2.36,0,0,0-.15-1.69,1.61,1.61,0,0,0-1.43-.86,4.1,4.1,0,0,0-1.78.49,75.43,75.43,0,0,0-13.78,9.57l-.14-.16a22.89,22.89,0,0,0,2.16-2.14,24.64,24.64,0,0,0,6.24-16.28,3.19,3.19,0,0,0-.56-1.86,1.51,1.51,0,0,0-1.69-.48,5.85,5.85,0,0,0-2.65,2.53,19.68,19.68,0,0,0-2.63,6.21,64.69,64.69,0,0,0-1.16,9.77C604.06,168.71,603.9,170,603.9,170Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-244"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.3,157.21c-4-1.83-12.19-.15-16,2-18.84,10.91-34.58,22.51-49.47,38.4a11.54,11.54,0,0,0-2.9,4.28,4.19,4.19,0,0,0,1.31,4.69,5.35,5.35,0,0,0,4.11.35c4.15-.91,6.08-1.11,11.09-4l36.06-14.43c2-4.15,5.85-7.07,9.5-9.91s7.38-5.93,9.1-10.22S185.5,159.14,181.3,157.21Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M131.18,191.09c-3.42,1.35-5.23,3.41-8.32,6.21a43.28,43.28,0,0,0-3.53,3.64,3.39,3.39,0,0,0-.7,2.57,3,3,0,0,0,2.42,1.94c3.19-1.44,4.84-4.41,7.29-6.91a9.67,9.67,0,0,0,1.86-2.46C130.65,195.15,131.5,192.08,131.18,191.09Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M175.25,163.84a4.35,4.35,0,0,0-4.52-1,22.15,22.15,0,0,0-8.53,4l.35.18a14.19,14.19,0,0,1,5.3,9.14c.17,1.19.45,2.73,1.64,2.94.9.16,1.67-.61,2.22-1.34a24.63,24.63,0,0,0,4.19-8.72C176.35,167.29,176.52,165.17,175.25,163.84Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M171.45,226.35s14.08,2.78,14.08,2.18,26.1-26.66,26.1-26.66l8.36,7.31-26,38H178l-10-7Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.45,226.35s14.08,2.78,14.08,2.18,26.1-26.66,26.1-26.66l8.36,7.31-26,38H178l-10-7Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.73,205.84c2.06-3.78,1.32-11.18-.49-15.09s-4.45-7.43-5.91-11.48c-1.94-5.36-1.73-11.39-4.2-16.53-1.92-4-5.28-7.06-8.56-10A76.42,76.42,0,0,0,211,167.54c-.18,5,.69,10.2,3.35,14.46,1.89,3,4.6,5.46,6.45,8.5,1.76,2.89,2.69,6.22,4.3,9.19s4.22,5.76,7.59,6.15",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.66,205.76c-2.37-6.71-9.4-5.58-12.33-5.67s-5.91.36-8.75-.36c-4.4-1.13-7.74-4.88-12.09-6.18-4.12-1.22-8.65,0-12.32,2.2s-6.64,5.43-9.55,8.59c4.95,2.11,10.52-1.54,15.88-1.1,4.59.38,8.43,3.68,12.92,4.67,8.69,1.92,17.84-5.06,26.24-2.15",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.14,183.83c-2.89-5.12-6.34-10.63-12-12.3-1.9-.56-4-.67-5.61-1.82-1.91-1.37-2.61-3.84-3.69-5.93A15.52,15.52,0,0,0,183,155.6c2.41,2.64,2.48,6.6,2.47,10.18s.22,7.57,2.82,10c2.36,2.23,6.06,2.56,8.38,4.83s2.6,5.53,3.72,8.42c2.07,5.34,9.08,10.13,14.74,11l14.59.58C224.16,198.81,220,188.94,217.14,183.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.59,156.33a17.62,17.62,0,0,1,.87,1.92,26.76,26.76,0,0,1,1.4,5.57c.4,2.39.6,5.28,1,8.46a27.59,27.59,0,0,0,2.74,9.95c1.8,3.22,4.41,5.7,6.08,8.46a57,57,0,0,1,4.09,7.47,39.77,39.77,0,0,1,2,5.39c.37,1.3.5,2,.5,2s-.06-.18-.15-.52-.23-.85-.43-1.5a42.15,42.15,0,0,0-2.06-5.35,59.82,59.82,0,0,0-4.12-7.43c-1.66-2.74-4.27-5.19-6.1-8.46a27.56,27.56,0,0,1-2.75-10c-.36-3.19-.54-6.07-.92-8.46a28.1,28.1,0,0,0-1.34-5.56c-.2-.65-.46-1.11-.58-1.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.25,205.59a6,6,0,0,1-1.44-.4,9.8,9.8,0,0,1-3.36-2.3A22.08,22.08,0,0,1,225,198a33.2,33.2,0,0,0-4-6.18c-1.77-1.92-3.81-3.43-5.21-5.26a19.73,19.73,0,0,1-3-5.24,19.49,19.49,0,0,1-1.06-3.94,13.26,13.26,0,0,1-.15-1.49s0,.13.07.38.08.62.16,1.09a20.31,20.31,0,0,0,4.14,9.08c1.39,1.8,3.42,3.3,5.21,5.24a32.87,32.87,0,0,1,4,6.22,22,22,0,0,0,3.44,4.93,10,10,0,0,0,3.28,2.33,6.19,6.19,0,0,0,1,.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.38,200.47a10.91,10.91,0,0,1-3.27.9,18.43,18.43,0,0,1-8.11-.89,38.39,38.39,0,0,1-7.4-3.54c-.9-.54-1.62-1-2.11-1.31l-.57-.36a.86.86,0,0,1-.19-.15l.21.11.59.33,2.15,1.25a41,41,0,0,0,7.38,3.47,19,19,0,0,0,8,.94,13,13,0,0,0,2.42-.49C226.07,200.57,226.38,200.45,226.38,200.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.84,156a13.61,13.61,0,0,1,1.81,1.71,19.85,19.85,0,0,1,3.67,5.69c.61,1.31.94,2.87,1.5,4.44a6,6,0,0,0,1.32,2.19,6.94,6.94,0,0,0,2.28,1.47c1.71.76,3.74,1.16,5.42,2.45a13.27,13.27,0,0,1,3.75,5.15c.94,2,1.69,4,2.69,5.79a22.1,22.1,0,0,0,3.55,4.72,35.26,35.26,0,0,0,8,6c2.5,1.4,4.61,2.38,6.06,3.06l1.67.79.57.28-.59-.24-1.69-.75c-1.46-.67-3.58-1.62-6.09-3a35.14,35.14,0,0,1-8.09-6A22.53,22.53,0,0,1,206.1,185c-1-1.82-1.76-3.83-2.69-5.8a13.35,13.35,0,0,0-3.69-5.08c-1.63-1.25-3.64-1.66-5.37-2.43a7.27,7.27,0,0,1-2.34-1.52,6.27,6.27,0,0,1-1.35-2.26c-.57-1.6-.88-3.14-1.47-4.44a20.44,20.44,0,0,0-3.6-5.7c-.53-.6-1-1-1.29-1.32S183.84,156,183.84,156Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.12,204.92s-.17-.08-.49-.26a10.89,10.89,0,0,0-1.46-.63,15,15,0,0,0-5.78-.64c-2.47.11-5.35.82-8.61,1.22a16,16,0,0,1-10.37-1.88,26,26,0,0,0-5.08-2.07,17,17,0,0,0-5.08-.38,42.54,42.54,0,0,0-8.5,1.72c-2.39.68-4.34,1.17-5.7,1.43a20.89,20.89,0,0,1-2.13.3l.54-.09,1.57-.29c1.36-.28,3.3-.8,5.68-1.49a41.52,41.52,0,0,1,8.53-1.77,17.09,17.09,0,0,1,5.14.37,26.29,26.29,0,0,1,5.13,2.08,18.19,18.19,0,0,0,5.15,1.84,18.5,18.5,0,0,0,5.09,0c3.25-.38,6.14-1.08,8.63-1.17a14.8,14.8,0,0,1,5.82.7A8,8,0,0,1,231.12,204.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.79 215.99 216.51 204.56 224.95 210.47 216.51 222.96 205.79 215.99",
    style: {
      fill: "#fcd2c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.22,166.28c-23.48-10.79-32.93,13.95-32.7,18.16.1,1.8,0,8.67-2.93,12.43-1.51,1.9.12,4.7-.29,7.1-.84,4.93,5.57,1.71,9.9,4.23s9.64,2.83,14.57,2",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.31,225.94a9.69,9.69,0,0,1-2.14-2.34c-.87-1.79.18-3.89,1.26-5.57s2.28-3.63,1.67-5.53-2.94-3.05-3.3-5.06a4.8,4.8,0,0,1,.83-3.19,13.93,13.93,0,0,0,1.57-3c.32-1.08-.27-3-1-4.22h0a19.36,19.36,0,0,1-2-4c-.95-3.9,2.8-7.73,2.07-11.68-.41-2.23-2.15-3.93-3.71-5.57s-1.06-9.48-9.3-9.48L151,211.38c1.83.47,6.07,2.94,9.93,2l1.74,18.92,13.23,2.6A8.24,8.24,0,0,0,174.31,225.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.55,217.17l-2.81-39.7a3.45,3.45,0,0,1,2.93-3.6l18-5.33c5.8-.85,10,6.17,10.56,12,.67,6.47,1.23,14.41.66,19.28-1.15,9.8-8.57,11.35-8.57,11.35s1.3,13.88,1.42,17.36",
    style: {
      fill: "#fcd2c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.11,188.53a1.24,1.24,0,0,1-1.15,1.3,1.18,1.18,0,0,1-1.33-1.07,1.24,1.24,0,0,1,1.15-1.31A1.2,1.2,0,0,1,167.11,188.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.78,185.66c-.12.17-1.19-.06-2.51.33s-2.17,1.17-2.34,1.09,0-.29.37-.64a4.54,4.54,0,0,1,1.84-1,4.2,4.2,0,0,1,2-.11C167.65,185.42,167.84,185.59,167.78,185.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.64,189.54a1.25,1.25,0,0,1-1.15,1.31,1.2,1.2,0,0,1-1.33-1.08,1.25,1.25,0,0,1,1.15-1.31A1.2,1.2,0,0,1,154.64,189.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.42,187.44c-.19.09-1.16-.56-2.67-.78s-2.69.12-2.83,0,.14-.25.66-.41a5.65,5.65,0,0,1,2.3-.12,5.12,5.12,0,0,1,2.1.76C154.4,187.16,154.52,187.4,154.42,187.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.06,196.21a8.87,8.87,0,0,1,2.17-.48c.34,0,.66-.13.71-.37a1.7,1.7,0,0,0-.27-1c-.35-.82-.73-1.67-1.12-2.57A44.06,44.06,0,0,1,158,185a46.34,46.34,0,0,1,3.09,6.53c.38.9.74,1.76,1.08,2.59a2,2,0,0,1,.23,1.34.87.87,0,0,1-.54.52,2.34,2.34,0,0,1-.58.11A8.42,8.42,0,0,1,159.06,196.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.32,211.17a23.56,23.56,0,0,1-13-2.82c.11,0,4,6.78,13.29,5.4Z",
    style: {
      fill: "#e2ad9a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.63,199.47a2.44,2.44,0,0,0-2.21-.81,2.25,2.25,0,0,0-1.5.88,1.42,1.42,0,0,0,0,1.61,1.63,1.63,0,0,0,1.78.37,5.12,5.12,0,0,0,1.68-1.09,1.49,1.49,0,0,0,.37-.42.45.45,0,0,0,0-.5",
    style: {
      fill: "#e2ad9a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.14,197.3c.22,0,.28,1.44,1.58,2.42s2.83.76,2.85,1-.33.29-1,.34a3.64,3.64,0,0,1-2.38-.72,3.15,3.15,0,0,1-1.22-2C154.9,197.66,155,197.29,155.14,197.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.25,182.65c-.12.37-1.47.25-3,.51s-2.83.73-3.05.41c-.1-.15.11-.5.61-.88a5.32,5.32,0,0,1,4.64-.7C154,182.2,154.3,182.47,154.25,182.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.34,181.78c-.23.32-1.17,0-2.28.07s-2.05.29-2.28,0c-.1-.15,0-.46.44-.76a3.29,3.29,0,0,1,3.67,0C166.29,181.32,166.43,181.63,166.34,181.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.79,167.27a92.51,92.51,0,0,0-21.09,6,8.32,8.32,0,0,0-4.1,2.88c-.94,1.54-.81,3.47-.66,5.26l2.22,26.19.94,0c2.7.43,2.89-.94,4.82-2.88a8.78,8.78,0,0,0,2.41-7.52c-.4-2.38-1.78-4.77-1-7.06,1-3,5.14-4.12,6.14-7.15.58-1.76-.08-3.77.59-5.5s2.28-2.61,3.89-3.27a16.71,16.71,0,0,0,4.7-2.25C160,170.79,160.73,168.74,159.79,167.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.79,183.39v.21c.12.33.25.66.36,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.34,448.05l-.2,18.89s19.13,6.54,19.43,10L159,477.9l-.9-29.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.78,465.64a1.48,1.48,0,0,0-1,1.73,1.44,1.44,0,0,0,1.71,1,1.57,1.57,0,0,0,1-1.84,1.48,1.48,0,0,0-1.89-.84",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159,477.9l0-3,35.11.22s1.65.66,1.49,1.82Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M176.73,466.73c0,.18-.89.29-1.76.88s-1.31,1.37-1.48,1.3.07-1.11,1.13-1.81S176.76,466.57,176.73,466.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.61,468.22c0,.18-.72.5-1.31,1.27s-.74,1.58-.92,1.58-.32-1,.43-2S180.6,468.05,180.61,468.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.91,472.77c-.16,0-.43-.85,0-1.84s1.26-1.4,1.34-1.25-.42.68-.77,1.5S183.09,472.74,182.91,472.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.3,462.43c-.07.16-.9-.06-1.91,0s-1.79.43-1.89.28.65-.81,1.84-.9S176.38,462.28,176.3,462.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "176.29 451.79 176.26 455.16 158.26 455.45 158.16 452.43 176.29 451.79"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M176.27,458.62a3.5,3.5,0,0,1-1.84,0,8.56,8.56,0,0,1-3-1.07,2.15,2.15,0,0,1-.56-.42.77.77,0,0,1-.11-1,1,1,0,0,1,.77-.42,2.4,2.4,0,0,1,.69.07,6.45,6.45,0,0,1,1.15.37,6.34,6.34,0,0,1,1.72,1.06c.87.77,1.18,1.43,1.12,1.46s-.51-.48-1.39-1.11a7.54,7.54,0,0,0-1.66-.88,6.87,6.87,0,0,0-1.06-.3c-.39-.09-.72-.09-.82.09s0,.09.05.2a1.63,1.63,0,0,0,.42.31,9.41,9.41,0,0,0,1,.53,9.94,9.94,0,0,0,1.79.63A12.21,12.21,0,0,1,176.27,458.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,458.88a3,3,0,0,1-.53-1.76,6.14,6.14,0,0,1,.2-2,5.62,5.62,0,0,1,.44-1.13,1.5,1.5,0,0,1,1.14-1,.85.85,0,0,1,.78.5,2.39,2.39,0,0,1,.21.66,4,4,0,0,1,0,1.24,4.2,4.2,0,0,1-.73,1.91c-.69,1-1.43,1.2-1.45,1.14s.55-.45,1.08-1.37a4.35,4.35,0,0,0,.53-1.74,3.82,3.82,0,0,0-.06-1.06c-.07-.39-.22-.7-.37-.65s-.48.3-.62.61a6.31,6.31,0,0,0-.74,2.85C175.93,458.18,176.14,458.85,176,458.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.82,421.86l-16.77,8.7s3.21,19.95.27,21.86l-18-31.89,25.56-14.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.86,419.91a1.5,1.5,0,0,0-2-.06,1.44,1.44,0,0,0-.08,2,1.57,1.57,0,0,0,2.11.05,1.48,1.48,0,0,0-.14-2.06",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.3,420.53l2.63-1.37,16.3,31.09s.18,1.77-.91,2.17Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M98.51,431c-.16.09-.67-.65-1.6-1.14s-1.82-.52-1.84-.7,1-.45,2.13.15S98.67,430.94,98.51,431Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,435.11c-.13.12-.78-.4-1.74-.56s-1.74.08-1.82-.08.74-.75,1.93-.53S99.16,435,99,435.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.09,439.27c-.12-.12.54-.78,1.62-.86s1.83.46,1.74.59-.81-.05-1.69,0S96.19,439.42,96.09,439.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.11,428.58c-.18,0-.37-.82-.93-1.67s-1.22-1.38-1.13-1.53,1,.19,1.66,1.19S102.27,428.58,102.11,428.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "111.49 423.58 108.51 425.13 99.79 409.38 102.42 407.87 111.49 423.58"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M105.46,426.76c-.07,0-.51-.52-.9-1.6a8.79,8.79,0,0,1-.43-2,9.32,9.32,0,0,1,0-1.19,2.4,2.4,0,0,1,.1-.7.8.8,0,0,1,.79-.54,1,1,0,0,1,.74.48,2.59,2.59,0,0,1,.26.65,7.38,7.38,0,0,1,.22,1.18,6.42,6.42,0,0,1-.13,2,3.14,3.14,0,0,1-.77,1.68c-.09,0,.19-.68.33-1.75a7.36,7.36,0,0,0,0-1.88,6.38,6.38,0,0,0-.24-1.08c-.1-.39-.26-.68-.46-.68s-.1,0-.16.14a1.74,1.74,0,0,0-.07.51c0,.38,0,.76,0,1.11A10.07,10.07,0,0,0,105,425,14.11,14.11,0,0,1,105.46,426.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.12,426.68c-.05,0,.33-.66,1.31-1.29a5.88,5.88,0,0,1,1.87-.77,6.47,6.47,0,0,1,1.2-.14,1.52,1.52,0,0,1,1.38.56.86.86,0,0,1-.07.92,2.92,2.92,0,0,1-.49.5,4.23,4.23,0,0,1-3.11.86c-1.18-.16-1.74-.71-1.69-.75a13.53,13.53,0,0,0,1.72.31,4.24,4.24,0,0,0,1.79-.35,3.41,3.41,0,0,0,.9-.55c.31-.24.52-.52.41-.63a1.07,1.07,0,0,0-.84-.26,6.41,6.41,0,0,0-1.09.09,6.8,6.8,0,0,0-1.77.59C105.68,426.26,105.19,426.76,105.12,426.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.49,308.6s-4.19,15.29-3.37,20.47c.28,1.75,1.58,7.11,2.47,11.24,1.55,7.2,3.07,16.18,3.48,18L144.68,371,99.51,407.64l11.27,20.74,43.72-27.74,1.53,12s-.39,28,.7,41.59l21.34-.74,3.67-70.58,5.9-73.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,412.29a.51.51,0,0,1-.05-.2c0-.17-.06-.37-.1-.61-.08-.58-.18-1.37-.3-2.35-.25-2.09-.6-5-1-8.66-.86-7.3-2.07-17.4-3.63-28.51s-3.19-21.15-4.63-28.36c-.73-3.6-1.32-6.52-1.83-8.51q-.35-1.45-.54-2.31a6.92,6.92,0,0,1-.16-.81,5.33,5.33,0,0,1,.25.79q.24.84.63,2.28c.57,2,1.21,4.89,2,8.49,1.53,7.21,3.22,17.24,4.77,28.36s2.72,21.23,3.49,28.54c.36,3.63.66,6.58.87,8.68.08,1,.15,1.77.2,2.36A8.14,8.14,0,0,1,156,412.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.46,246.41l12.66,39.33s-6.46,22-5.32,30.62c.66,5,2.8,14.32,2.8,14.32l47.52-3.21s.43-54.46-7.51-78.79c-4.66-14.29-17.62-27-17.62-27h0l-.21-9.1-24.19.35-.52,7.25S127.73,234.61,130.46,246.41Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.41,265.77a1.08,1.08,0,0,1,0,.24c0,.2,0,.43-.07.68-.05.59-.16,1.45-.31,2.5a78.68,78.68,0,0,1-1.67,8.16,75.54,75.54,0,0,1-2.56,7.92c-.39,1-.71,1.8-1,2.34-.1.23-.19.44-.28.63a2.28,2.28,0,0,1-.1.21,1.05,1.05,0,0,1,.07-.23c.08-.19.16-.4.25-.64.22-.55.53-1.35.9-2.35.73-2,1.67-4.79,2.5-7.93s1.38-6,1.72-8.13c.17-1.05.29-1.9.37-2.49,0-.25.07-.47.1-.68S148.4,265.76,148.41,265.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.81,223.47c-3,.37-4.95.89-8.44,4.63s-4.68,14.52-4.68,14.52l17.23,8.7,39.58,5s8.43,1.9,15.67-9.34c2.65-4.12,20.94-31.39,20.94-31.39l-12-8-24.22,25.9Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,253l-.41.37a10.53,10.53,0,0,1-1.26,1,13,13,0,0,1-5.42,2.08,12.71,12.71,0,0,1-4,0c-1.44-.16-3-.36-4.59-.57-3.23-.44-6.77-1-10.48-1.61l-19-3.33-5.76-.94-1.57-.25-.54-.1.55.06,1.57.22c1.36.19,3.34.49,5.77.88,4.87.78,11.56,2,19,3.28,3.71.62,7.25,1.17,10.47,1.62,1.62.22,3.15.42,4.59.59a13.21,13.21,0,0,0,9.39-2,12.69,12.69,0,0,0,1.28-.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.55,241.29a.63.63,0,0,1-.06-.2c0-.17-.07-.36-.11-.56-.1-.48-.22-1.19-.34-2.07a18.14,18.14,0,0,1,.17-6.91,9.68,9.68,0,0,1,3.85-5.64A6.37,6.37,0,0,1,142,225a3.75,3.75,0,0,1,.76-.14,7.76,7.76,0,0,0-2.61,1.12,9.72,9.72,0,0,0-3.74,5.58,19,19,0,0,0-.22,6.85c.1.87.21,1.58.28,2.07,0,.2.06.39.08.57A1.47,1.47,0,0,1,136.55,241.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188,247.19a2.44,2.44,0,0,1,0-.54c.05-.46.09-.94.14-1.47a46.31,46.31,0,0,0,.14-4.87,45.66,45.66,0,0,0-.38-4.85c-.08-.52-.15-1-.21-1.46a3.08,3.08,0,0,1-.07-.54,2.23,2.23,0,0,1,.14.52c.08.35.17.84.27,1.46a37.67,37.67,0,0,1,.44,4.87,36.26,36.26,0,0,1-.2,4.88c-.07.62-.13,1.13-.19,1.47A3,3,0,0,1,188,247.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.44,222.79a15.68,15.68,0,0,0-2.72-4.76c-1.79-2.42-3.71-4.94-6.49-6.08-1.9-.78-6.79-.35-8.09-1.93-4.06-4.92,1.89-8-.27-14.76-2.37-7.42-1.15-6.28-1.33-12.12l-9-3.9c-1.42,1.06-5.36,4.89-4.93,6.61a10.27,10.27,0,0,1-.34,5.68c-1.39,4.35-6.18,6.92-8.45,10.88s.3,9.45.36,14.13-1.71,10.31-6.27,11.32a17.67,17.67,0,0,0,8,8l2.87-3.9a7.62,7.62,0,0,0,5.27,8.26c1-4.1,2-8.33,4.46-11.74s6.85-5.81,10.93-4.72c2.72.73,4.83,2.83,7.26,4.26s5.89,2,7.84,0A5.37,5.37,0,0,0,161.44,222.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M179.17,255.23c-11.41-2.08-26.6-4.57-38-6.65a2.32,2.32,0,0,0-1.28,0,1.57,1.57,0,0,0-.64,2.09,3.78,3.78,0,0,0,1.79,1.6c3.74,1.95,8.13,2.11,12.35,2.23,7.21.19,18.58.53,25.79.73Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M130.46,246.41l12.66,39.33s-6.46,22-5.32,30.62c.66,5,2.8,14.32,2.8,14.32l47.52-3.21s.43-54.46-7.51-78.79c-4.66-14.29-17.62-27-17.62-27h0l-.21-9.1-24.19.35-.52,7.25S127.73,234.61,130.46,246.41Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.5,256.36c-3.55.08-44.39-7.39-44.39-7.39",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.41,265.77a1.08,1.08,0,0,1,0,.24c0,.2,0,.43-.07.68-.05.59-.16,1.45-.31,2.5a78.68,78.68,0,0,1-1.67,8.16,75.54,75.54,0,0,1-2.56,7.92c-.39,1-.71,1.8-1,2.34-.1.23-.19.44-.28.63a2.28,2.28,0,0,1-.1.21,1.05,1.05,0,0,1,.07-.23c.08-.19.16-.4.25-.64.22-.55.53-1.35.9-2.35.73-2,1.67-4.79,2.5-7.93s1.38-6,1.72-8.13c.17-1.05.29-1.9.37-2.49,0-.25.07-.47.1-.68S148.4,265.76,148.41,265.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.44,222.79a15.68,15.68,0,0,0-2.72-4.76c-1.79-2.42-3.71-4.94-6.49-6.08-1.9-.78-6.79-.35-8.09-1.93-4.06-4.92,1.89-8-.27-14.76-2.37-7.42-1.15-6.28-1.33-12.12l-9-3.9c-1.42,1.06-5.36,4.89-4.93,6.61a10.27,10.27,0,0,1-.34,5.68c-1.39,4.35-6.18,6.92-8.45,10.88s.3,9.45.36,14.13-1.71,10.31-6.27,11.32a17.67,17.67,0,0,0,8,8l2.87-3.9a7.62,7.62,0,0,0,5.27,8.26c1-4.1,2-8.33,4.46-11.74s6.85-5.81,10.93-4.72c2.72.73,4.83,2.83,7.26,4.26s5.89,2,7.84,0A5.37,5.37,0,0,0,161.44,222.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M162.39,311c-1.13-4.7-3.55-9.27-7.53-12s-9.65-3.31-13.61-.55l-1.52,1c3.56.16,8.16,1.47,10.6,4.07s2.5,6.88,2.47,10.61a119.84,119.84,0,0,0,6.87,41c.77,2.16,1.68,4.41,3.49,5.83q.14-17.76.28-35.52C163.48,320.63,163.51,315.73,162.39,311Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M160.89,252.28s.89,28-7,32.93a120.71,120.71,0,0,1-12.54,7,51.94,51.94,0,0,0-1.74,7.28s16.68-1.22,17.08,4.95,7.1,58.33,7.1,58.33h33.48L184.56,256.1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.43,296.08s-.09.17-.3.45a13.79,13.79,0,0,1-1,1.2,18.57,18.57,0,0,1-4.51,3.54,10,10,0,0,1-1.74.83,3.25,3.25,0,0,1-2.16,0,2,2,0,0,1-1.37-1.87,3.27,3.27,0,0,1,1.24-2.12,10.64,10.64,0,0,1,4.52-2.35,11,11,0,0,1,5.47-.07l-.1.51-.45-.06a22.09,22.09,0,0,1-9.95-3.64,4.7,4.7,0,0,1-1-.84,1.41,1.41,0,0,1-.31-1.3,1.45,1.45,0,0,1,1-.89,3.63,3.63,0,0,1,1.16-.17,10.17,10.17,0,0,1,3.92,1.13,14,14,0,0,1,4.54,3.68,11.67,11.67,0,0,1,.89,1.33,1.79,1.79,0,0,1,.23.5s-.39-.66-1.28-1.7a14.53,14.53,0,0,0-4.54-3.48,10,10,0,0,0-3.77-1c-.64,0-1.48.17-1.66.75s.46,1.19,1.1,1.62a22.09,22.09,0,0,0,9.74,3.52l.44.05-.1.51a10.55,10.55,0,0,0-5.21.07,10.08,10.08,0,0,0-4.32,2.2,2.87,2.87,0,0,0-1.1,1.79,1.54,1.54,0,0,0,1.07,1.45,2.82,2.82,0,0,0,1.88,0,10.38,10.38,0,0,0,1.69-.77,20.58,20.58,0,0,0,4.54-3.36C139.94,296.64,140.4,296.05,140.43,296.08Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.81,223.47c-3,.37-4.95.89-8.44,4.63s-4.68,14.52-4.68,14.52l17.23,8.7,39.58,5s8.43,1.9,15.67-9.34c2.65-4.12,20.94-31.39,20.94-31.39l-12-8-24.22,25.9Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,253l-.41.37a10.53,10.53,0,0,1-1.26,1,13,13,0,0,1-5.42,2.08,12.71,12.71,0,0,1-4,0c-1.44-.16-3-.36-4.59-.57-3.23-.44-6.77-1-10.48-1.61l-19-3.33-5.76-.94-1.57-.25-.54-.1.55.06,1.57.22c1.36.19,3.34.49,5.77.88,4.87.78,11.56,2,19,3.28,3.71.62,7.25,1.17,10.47,1.62,1.62.22,3.15.42,4.59.59a13.21,13.21,0,0,0,9.39-2,12.69,12.69,0,0,0,1.28-.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.55,241.29a.63.63,0,0,1-.06-.2c0-.17-.07-.36-.11-.56-.1-.48-.22-1.19-.34-2.07a18.14,18.14,0,0,1,.17-6.91,9.68,9.68,0,0,1,3.85-5.64A6.37,6.37,0,0,1,142,225a3.75,3.75,0,0,1,.76-.14,7.76,7.76,0,0,0-2.61,1.12,9.72,9.72,0,0,0-3.74,5.58,19,19,0,0,0-.22,6.85c.1.87.21,1.58.28,2.07,0,.2.06.39.08.57A1.47,1.47,0,0,1,136.55,241.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188,247.19a2.44,2.44,0,0,1,0-.54c.05-.46.09-.94.14-1.47a46.31,46.31,0,0,0,.14-4.87,45.66,45.66,0,0,0-.38-4.85c-.08-.52-.15-1-.21-1.46a3.08,3.08,0,0,1-.07-.54,2.23,2.23,0,0,1,.14.52c.08.35.17.84.27,1.46a37.67,37.67,0,0,1,.44,4.87,36.26,36.26,0,0,1-.2,4.88c-.07.62-.13,1.13-.19,1.47A3,3,0,0,1,188,247.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M179.17,255.23c-11.41-2.08-26.6-4.57-38-6.65a2.32,2.32,0,0,0-1.28,0,1.57,1.57,0,0,0-.64,2.09,3.78,3.78,0,0,0,1.79,1.6c3.74,1.95,8.13,2.11,12.35,2.23,7.21.19,18.58.53,25.79.73Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M149.81,169.13c-8.45,5.6-15.52,12.29-22.88,19.26l-3.23,8.18c8.74-7,16.13-13.56,25.23-20.54a153.76,153.76,0,0,1,28.43-17.57C167.24,159.14,158.26,163.53,149.81,169.13Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.47,158.28c-6.18.12-13.88,3.87-17.32,9s-3.8,15.61-1.58,21.37l34.88-22.46A19.66,19.66,0,0,0,146.47,158.28Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.34,159.24l-.41.25-1.22.69c-1.05.59-2.57,1.47-4.42,2.59-3.71,2.23-8.74,5.49-14.1,9.35s-10.06,7.57-13.38,10.35c-1.67,1.38-3,2.54-3.9,3.33l-1,.92-.38.31.35-.34,1-.95c.9-.81,2.21-2,3.86-3.38,3.3-2.81,8-6.55,13.36-10.41s10.41-7.1,14.14-9.31c1.87-1.1,3.39-2,4.46-2.53l1.24-.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.09,186.63s-.59.45-1.7,1.16a42.24,42.24,0,0,1-4.92,2.65,38.43,38.43,0,0,1-3.6,1.45,2.45,2.45,0,0,1-1.08.06,1,1,0,0,1-.8-.8,2.59,2.59,0,0,1,1.09-2,11.16,11.16,0,0,1,9.45-2.91c.34,0,.67.15,1,.21l-.05.2a14.23,14.23,0,0,1-8.21-5.15,3,3,0,0,1-.5-1,1.42,1.42,0,0,1,.12-1.12,1.32,1.32,0,0,1,.92-.58,2.64,2.64,0,0,1,1,0,8.58,8.58,0,0,1,3.26,1.77,12.78,12.78,0,0,1,3.28,4.22,10,10,0,0,1,.71,1.82s-.07-.16-.19-.47-.31-.76-.59-1.32a13.31,13.31,0,0,0-3.3-4.14A8.51,8.51,0,0,0,119.8,179a1.6,1.6,0,0,0-1.77.47,1.8,1.8,0,0,0,.38,1.93,14.09,14.09,0,0,0,8.09,5.06l0,.2c-.3-.06-.62-.16-1-.2a11,11,0,0,0-9.28,2.83c-.55.52-1.13,1.14-1,1.84a.82.82,0,0,0,.66.65,2.12,2.12,0,0,0,1-.05c1.3-.42,2.5-.94,3.58-1.41a45.12,45.12,0,0,0,4.94-2.59l1.28-.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.22,163.76a3,3,0,0,0-.38-.84,3.55,3.55,0,0,0-2-1.39,8.84,8.84,0,0,0-3.72.05,32.75,32.75,0,0,0-4.5,1,35.36,35.36,0,0,0-7.71,3.3c-.93.54-1.66,1-2.16,1.34l-.58.39q-.19.13-.21.12a1.5,1.5,0,0,1,.19-.15l.55-.42c.49-.35,1.21-.85,2.14-1.4a33,33,0,0,1,7.72-3.38,31.6,31.6,0,0,1,4.53-1,8.77,8.77,0,0,1,3.79,0,3.55,3.55,0,0,1,2.06,1.49A1.94,1.94,0,0,1,182.22,163.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.44,190.43s-4.46,4-5.4,4.84-2.73,6.6-2.73,6.6l-5.53,4,11.58,7.92,2.38-5.51s7.4-4.94,7.66-6c.4-1.62.76-2.1.38-3.12a1.49,1.49,0,0,0-1.46-.93l-.35-.87s-.16-4-.72-4.3-1.25-.66-1.25-.66C233,191.22,232.21,186.41,227.44,190.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.76,211.76c0,.05-2.19-1.49-4.81-3.43s-4.73-3.55-4.7-3.59,2.19,1.49,4.82,3.42S225.8,211.71,225.76,211.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.56,192.11s-.78.78-1.54,1.89-1.16,2.15-1.22,2.12a7.62,7.62,0,0,1,2.76-4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.39,191.89a4,4,0,0,1-.82,1.36,3.63,3.63,0,0,1-1.17,1.07s.47-.53,1-1.2A13,13,0,0,1,232.39,191.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.79,194.88a2.44,2.44,0,0,1-.44,1.26,2.58,2.58,0,0,1-.87,1s.33-.5.69-1.12A11.51,11.51,0,0,1,233.79,194.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.48,198.4s-.15.29-.41.55-.52.45-.56.41.14-.29.41-.55S234.44,198.36,234.48,198.4Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-244"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M373.27,381.57l-2.54-8c-2.4-3.84-5-7.79-8.92-10s-9.58-2.14-12.36,1.43c-1.31,1.7-1.8,3.9-3,5.7-1.45,2.2-3.81,3.6-6.1,4.89s-4.69,2.6-6.28,4.69-2.19,5.21-.62,7.33c2,2.76,6.36,2.47,9,4.6,2.1,1.68,2.83,4.56,4.62,6.57,3.46,3.9,9.56,3.5,14.73,2.78,5-.71,10.68-1.81,13.37-6.1S376.4,385.46,373.27,381.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.13,366.76l1.79.67-1.55.44a1.63,1.63,0,0,0-1.1,1.05l-.56,1.72-.69-1.72a1.6,1.6,0,0,0-.95-.92l-1.57-.57,1.7-.7a1.64,1.64,0,0,0,.9-.91l.61-1.6.44,1.49A1.65,1.65,0,0,0,333.13,366.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.89,380.27l1.15.44-1,.28a1,1,0,0,0-.71.67l-.36,1.11-.44-1.11a1,1,0,0,0-.61-.59l-1-.36,1.09-.45a1.05,1.05,0,0,0,.58-.59l.39-1,.28,1A1.05,1.05,0,0,0,325.89,380.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371,359l1.14.43-1,.28a1.05,1.05,0,0,0-.71.68l-.36,1.1-.44-1.11a1,1,0,0,0-.61-.59l-1-.36,1.09-.45a1,1,0,0,0,.58-.59l.39-1,.29.95A1,1,0,0,0,371,359Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362,355.33l.57.21-.5.14a.54.54,0,0,0-.35.34l-.18.55-.22-.55a.54.54,0,0,0-.31-.3l-.5-.18.55-.22a.52.52,0,0,0,.28-.3l.2-.51.14.48A.54.54,0,0,0,362,355.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.51,400.19l.57.21-.49.14a.55.55,0,0,0-.36.34l-.18.55-.22-.55a.5.5,0,0,0-.3-.3l-.51-.18.55-.22a.57.57,0,0,0,.29-.3l.19-.51.14.48A.57.57,0,0,0,337.51,400.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.87,259c-3.65-.73-8.43,1.67-11.52,3.74-2.85,1.91-4,4.87-4.81,7.1,0,0-3.31.59-3.24,4.88,0,1.83,2.12,3.13,2.27,4.95.06.69-.66,1.83-.84,4.14-.17,2.13.21,4.29,2.53,7.68,1.21,1.77,3.69,2.94,4.83,4.75,1.65,2.63,3.78,5.27,5.29,8,1.38,2.51,2.81,3.84,5.66,4.12l8.27-45.18C408.16,260.1,405.52,259.68,401.87,259Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.83,306.73,430,321.44l-6.4,13.25L415,328.78l-2.81-8-2.37-6.69s-9.32,1.88-12.67-6.89c-1.62-4.24-4.25-13.24-6.54-21.41a17.52,17.52,0,0,1,10.81-21.14l.85-.31c9.37-2.85,17,3.52,19.6,13l10.92,29.4",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396,292.85a1.35,1.35,0,0,0,1.69.83,1.29,1.29,0,0,0,.88-1.62,1.35,1.35,0,0,0-1.68-.82A1.29,1.29,0,0,0,396,292.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.92,289.12c.22.1.91-.95,2.27-1.45s2.6-.18,2.68-.4-.22-.34-.77-.5a3.76,3.76,0,0,0-2.22.12,3.57,3.57,0,0,0-1.73,1.36C393.85,288.72,393.82,289.07,393.92,289.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.31,288.08a1.34,1.34,0,0,0,1.68.82,1.29,1.29,0,0,0,.88-1.61,1.34,1.34,0,0,0-1.68-.82A1.27,1.27,0,0,0,408.31,288.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.28,283.76c.21.13,1-.85,2.41-1.19s2.61.1,2.71-.11-.18-.36-.71-.58a3.72,3.72,0,0,0-2.22-.12,3.57,3.57,0,0,0-1.87,1.16C407.25,283.36,407.18,283.7,407.28,283.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.42,296.73a9.69,9.69,0,0,0-2.35.42c-.35.09-.71.14-.85-.07a1.82,1.82,0,0,1-.15-1.11c0-1,0-2,.05-3,0-4.28-.07-7.74-.24-7.74s-.34,3.46-.38,7.74v3a2.09,2.09,0,0,0,.32,1.42.91.91,0,0,0,.75.3,2.47,2.47,0,0,0,.62-.14A9.24,9.24,0,0,0,406.42,296.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.75,296.2c-.22.07.32,1.54-.56,3.05s-2.5,1.92-2.43,2.13.45.16,1.12-.07a3.83,3.83,0,0,0,2.06-1.69,3.38,3.38,0,0,0,.38-2.52C411.15,296.46,410.85,296.16,410.75,296.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.8,279.24c.25.34,1.59-.22,3.27-.48s3.13-.17,3.26-.57c.05-.19-.28-.48-.91-.7a5.53,5.53,0,0,0-2.58-.17,5.4,5.4,0,0,0-2.39,1C405.92,278.7,405.7,279.08,405.8,279.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.28,285.43c.35.22,1.17-.45,2.28-.88s2.15-.55,2.25-.95c0-.2-.22-.45-.74-.59a3.4,3.4,0,0,0-2.06.19,3.36,3.36,0,0,0-1.6,1.29C393.13,285,393.12,285.32,393.28,285.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.43,262.72a7.12,7.12,0,0,1-5.6,9.4c-1.6.25-3.51.06-4.53,1.32s-.41,3.39-1.25,4.87c-1.21,2.1-4.45,1.65-6.42,3.07-1.52,1.1-2,3.09-2.66,4.85s-1.89,3.64-3.76,3.73a21.52,21.52,0,0,1-.91-4.76,7.19,7.19,0,0,1,1.28-4.59,22,22,0,0,0,1.73-2c1-1.63.65-3.72,1-5.61a7.83,7.83,0,0,1,4.31-5.68c1.86-.87,4.06-1,5.77-2.11,1.27-.84,2.17-2.17,3.49-2.93,2.56-1.48,5.8-.4,8.47.87",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.79,284a1.83,1.83,0,0,1-.46.38c-3,1.9-5.72-4.39-5.62-6.49a20.4,20.4,0,0,1-4.53-2.32,14.63,14.63,0,0,1-3.84-6.14c-1.17.48-6.81.58-6.33.24,1.11-.79,3.35-2.46,3.64-3.76a7.94,7.94,0,0,1,5.23-6,6.57,6.57,0,0,1,7.3,3,9.44,9.44,0,0,1,9.39,2.26c2.53,2.43,2.83,6.13,2.16,9.56a9.19,9.19,0,0,0,0,3.62c.36,1.1,1.19,1.46,1.72,2.46,2.23,4.16,1.38,13-2.14,16.5",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.37,284.33c.13-.12,5.4-4,7.43,2.07s-4.52,6.88-4.58,6.7S422.37,284.33,422.37,284.33Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.31,290.18s.13,0,.34.06a1.16,1.16,0,0,0,.8-.25,2.79,2.79,0,0,0,.43-2.76,3.83,3.83,0,0,0-.8-1.43,1.32,1.32,0,0,0-1.08-.55.59.59,0,0,0-.53.5c0,.2.06.31,0,.33s-.16-.06-.2-.32a.8.8,0,0,1,.11-.47.9.9,0,0,1,.54-.35,1.57,1.57,0,0,1,1.42.58,3.73,3.73,0,0,1,.94,1.58,2.88,2.88,0,0,1-.68,3.14,1.19,1.19,0,0,1-1,.17C426.37,290.32,426.29,290.19,426.31,290.18Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.94,314.22a21.85,21.85,0,0,0,10.29-7.5s-.38,7.34-9.47,9.79Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.07,443.34l.88,22.35s-22.42,8.39-22.66,12.54l43.39-.15.06-34.87Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.36,463.76a1.78,1.78,0,0,1,1.23,2,1.71,1.71,0,0,1-2,1.24,1.87,1.87,0,0,1-1.29-2.15,1.76,1.76,0,0,1,2.21-1.05",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423.68,478.08l-.13-3.51L382,476s-1.93.85-1.71,2.21Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M402.24,465.47c0,.21,1.07.3,2.12,1s1.6,1.57,1.79,1.48-.12-1.31-1.4-2.1S402.2,465.27,402.24,465.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.7,467.37c-.05.2.87.56,1.59,1.45s.94,1.84,1.15,1.83.34-1.21-.58-2.3S397.7,467.16,397.7,467.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.13,472.82c.2.05.49-1-.06-2.17s-1.54-1.62-1.63-1.44.53.79,1,1.75S394.92,472.8,395.13,472.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.61,460.35c.09.2,1.06-.1,2.26,0s2.13.45,2.24.27-.79-.94-2.2-1S402.5,460.19,402.61,460.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.33,472.56l22.11-3.31s10.8,21.37,14.94,21.16l-4.88-43.12L516.83,451Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.07,456.13a1.76,1.76,0,0,1,1.87-1.44,1.71,1.71,0,0,1,1.45,1.84,1.88,1.88,0,0,1-2,1.52,1.77,1.77,0,0,1-1.3-2.08",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M551.5,447.29l-3.48.52L554,489s1,1.83,2.38,1.46Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M541.3,470c.21,0,.19-1.1.75-2.21s1.38-1.77,1.28-1.95-1.29.27-1.94,1.63S541.12,470,541.3,470Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.69,474.29c.2,0,.46-.93,1.27-1.75s1.73-1.13,1.69-1.34-1.23-.2-2.22.83S543.48,474.3,543.69,474.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.39,476.24c0-.2-1.06-.37-2.16.3s-1.43,1.71-1.25,1.78.73-.61,1.64-1.15S549.39,476.45,549.39,476.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.18,470.17c.18-.11-.22-1-.27-2.24s.21-2.17,0-2.26-.84.89-.76,2.3S536,470.29,536.18,470.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.1,314.41s2.91-9.06,8.37-9.81,11.94-.49,16.37,1.13c5.2,1.9,21.21,17.57,31.72,28.24a106.4,106.4,0,0,1,20,28.12c2.89,6,4.93,11.68,3.57,13.86l-33.65,1.61-25.07,4.1S420,351.09,420.32,350.52,416.1,314.41,416.1,314.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.2,406.73S452,463.3,454,468s4.39,8.24,12.63,9.89,70-2.75,70-2.75l-3-27.73-44-4s-.19-12.44.09-18.21,6.72-16.56,7.54-29.46S451.2,406.73,451.2,406.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.64,442.86c0,.05-.8.42-2.05,1.12A28.22,28.22,0,0,0,484,447.2a28.8,28.8,0,0,0-3.81,4.1c-.87,1.14-1.33,1.9-1.38,1.87a2.4,2.4,0,0,1,.27-.56,13.59,13.59,0,0,1,.92-1.45,23.41,23.41,0,0,1,8.46-7.39,15.72,15.72,0,0,1,1.56-.71A2.33,2.33,0,0,1,490.64,442.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.92,459.26a3.47,3.47,0,0,1,.1-.69c.08-.44.22-1.07.43-1.84a37.68,37.68,0,0,1,2.12-5.89,38.26,38.26,0,0,1,3.05-5.46c.45-.66.83-1.18,1.11-1.53a3.23,3.23,0,0,1,.46-.53s-.53.84-1.37,2.19a47.71,47.71,0,0,0-2.95,5.47,48.61,48.61,0,0,0-2.19,5.81C483.21,458.32,483,459.28,482.92,459.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M451.49,418.74l0,.24a25.15,25.15,0,0,0,16.61,5.2,28.42,28.42,0,0,0,17-7.5C474.51,419.66,462.39,419.53,451.49,418.74Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M496.93,373.67c-3.3-3.84-47.92,4.23-47.92,4.23s-44.22,1.92-50.81,3-12.76,12.56-12.76,19.42,5.91,58.92,5.91,58.92l37.37-3.8c-.28-4.94-4.15-40.49-4.15-40.49s13.54,2.59,26.92,3.77c4.17.37,18.77.35,20.86.09,8.78-1.1,18.67-9.9,22-14.57S500.23,377.52,496.93,373.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411,402.29a4.41,4.41,0,0,1,.78.13,8.16,8.16,0,0,1,.89.24,11.67,11.67,0,0,1,1.17.4,19.25,19.25,0,0,1,2.87,1.41,20.9,20.9,0,0,1,3.13,2.38,20.26,20.26,0,0,1,2.57,3A17.53,17.53,0,0,1,424,412.6a10.6,10.6,0,0,1,.47,1.13,8.41,8.41,0,0,1,.3.88,3.47,3.47,0,0,1,.18.77c-.07,0-.37-1.07-1.17-2.68a19,19,0,0,0-1.63-2.7,19.5,19.5,0,0,0-5.6-5.26,20.07,20.07,0,0,0-2.8-1.46C412.1,402.59,411,402.36,411,402.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.72,408.06a1.87,1.87,0,0,1,.57.07,15.26,15.26,0,0,1,1.52.36,24.75,24.75,0,0,1,4.79,1.91,25.26,25.26,0,0,1,4.31,2.85c.5.42.9.78,1.16,1s.4.41.38.43-.65-.5-1.69-1.29a30.67,30.67,0,0,0-9-4.71C412.5,408.31,411.71,408.11,411.72,408.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.78,416.74l-.16.05-.45.11-1.76.37c-.76.16-1.7.35-2.8.51s-2.34.41-3.72.56l-2.18.27c-.76.09-1.55.14-2.36.22-1.64.17-3.39.25-5.24.35-3.69.14-7.75.15-12-.05a190.14,190.14,0,0,1-21.66-2.45c-2.76-.47-5-.88-6.51-1.2l-1.75-.36-.46-.1c-.1,0-.16,0-.15,0l.16,0,.46.06,1.77.3c1.53.28,3.76.65,6.51,1.09a203.36,203.36,0,0,0,21.65,2.35c4.25.2,8.3.2,12,.08,1.84-.1,3.59-.16,5.22-.32.82-.07,1.61-.12,2.36-.2l2.18-.25c1.38-.14,2.63-.35,3.72-.5s2-.32,2.81-.46l1.77-.31.46-.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.74,354.81a4.16,4.16,0,0,1-.51.68c-.34.43-.85,1-1.5,1.76-1.29,1.47-3.16,3.43-5.35,5.46s-4.3,3.72-5.87,4.89c-.78.59-1.42,1-1.88,1.36a4.31,4.31,0,0,1-.72.45,4.26,4.26,0,0,1,.65-.56l1.8-1.44c1.53-1.22,3.6-2.94,5.79-5s4.07-3.95,5.41-5.37l1.58-1.69A3.36,3.36,0,0,1,471.74,354.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.18,354.33a10.15,10.15,0,0,1-.3,2c-.24,1.23-.61,2.91-1.13,4.75s-1.06,3.48-1.48,4.66a10.61,10.61,0,0,1-.78,1.86,13,13,0,0,1,.55-1.94c.37-1.19.88-2.84,1.39-4.67s.92-3.5,1.22-4.71A13.63,13.63,0,0,1,456.18,354.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.09,369.88a3.68,3.68,0,0,1-.58.46,17.17,17.17,0,0,1-1.67,1.08,25.68,25.68,0,0,1-5.87,2.52,24,24,0,0,1-6.17.93c-.79,0-1.44,0-1.88-.06a3.77,3.77,0,0,1-.69-.1,2.34,2.34,0,0,1,.7,0c.44,0,1.08,0,1.87,0a27.89,27.89,0,0,0,6.11-1,29.84,29.84,0,0,0,5.85-2.41c.72-.39,1.3-.73,1.7-1A2.83,2.83,0,0,1,451.09,369.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.16,337.5s-5.94,13.32-7.56,20.65l-35.8,17.43L372.61,386s42.51-5.06,45.4-6.61,8.33-8.41,10.46-13.27,7.67-18.69,7.67-18.69Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414,359.73s-.49-.28-1.29-.68a11.59,11.59,0,0,0-3.3-1,11.17,11.17,0,0,0-3.45,0c-.88.15-1.41.32-1.43.27a4,4,0,0,1,1.39-.5,9.51,9.51,0,0,1,3.54-.14,9.65,9.65,0,0,1,3.36,1.16A4,4,0,0,1,414,359.73Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.43,374.82s-5.35-1.27-7.93-1.05-14.24,2.83-14.24,2.83-.9,2.1,2,3,6.84,0,6.84,0-7.18,5.72-7.29,6.17-1,1.46.11,2.24,4.49,0,4.49,0,0,2.47,1,3.14,1.9,1.23,1.9,1.23a10.48,10.48,0,0,0,2.92,2.25c1.12.33,3.36.78,3.36.78H366l9.08-7.68,7.83-1.69-5-15.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.92,386.34a8.34,8.34,0,0,1-2.62,1.18,8.1,8.1,0,0,1-2.83.54,27.11,27.11,0,0,1,2.72-.86A23.85,23.85,0,0,1,358.92,386.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.68,379.85a30.84,30.84,0,0,1,.13,4.11,32.65,32.65,0,0,1-.06,4.11,34.6,34.6,0,0,1-.07-8.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.46 372.95 378.26 387.04 381.52 386.34 375.96 371.79 373.46 372.95",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.88,307.19s-10.86,2.85-13,7.65-8.81,28.37-8.81,28.37l29.07,10.26s3.74-16.73,5.35-23.14S448.11,311.64,428.88,307.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.07,343.21l.16,0,.45.14,1.74.57,6.37,2.15,21,7.25-.23.14.09-.55c1.43-8.7,2.73-16.59,3.67-22.32.48-2.84.87-5.14,1.15-6.76l.33-1.84.09-.47c0-.11,0-.16.05-.16s0,.05,0,.16l-.06.48c-.07.45-.16,1.07-.27,1.85-.25,1.63-.61,3.94-1,6.78-.92,5.74-2.18,13.62-3.57,22.34,0,.18-.07.37-.09.54l0,.2-.19-.07-21-7.34-6.34-2.26-1.71-.63-.44-.17C407.12,343.24,407.07,343.22,407.07,343.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.69,324.82a2.21,2.21,0,0,1,0,.59c0,.37-.12.9-.24,1.56a38,38,0,0,1-3.32,9.86c-.3.6-.56,1.07-.75,1.39s-.31.5-.33.48a18.75,18.75,0,0,1,.86-2c.55-1.21,1.25-2.9,1.9-4.82s1.11-3.7,1.4-5A19.26,19.26,0,0,1,443.69,324.82Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAidiAboutUscrdImg3);
export default __webpack_public_path__ + "static/media/AIDIAboutUscrdImg3.09f9d604803189008cf40a3b3132edab.svg";
export { ForwardRef as ReactComponent };